import { IconConfig } from './Icon';

export const alertDots: IconConfig = {
  width: 40,
  height: 37,
  paths: [
    {
      d: 'M15.1805 2.44332C15.99 1.29034 17.3083 0.420274 18.7485 0.0887418C19.374 -0.0552825 20.8632 -0.0181123 21.51 0.157637C22.8797 0.52989 24.1896 1.4941 24.9733 2.70714C25.582 3.64918 39.0564 27.2261 39.3969 27.9448C40.1151 29.4607 40.1909 30.9659 39.6295 32.5658C39.3153 33.4615 38.9618 34.0116 38.2136 34.7689C37.5228 35.468 36.9874 35.8354 36.1786 36.1649C36.0685 36.2097 35.9763 36.2498 35.8825 36.2856C35.0606 36.5995 34.1137 36.5862 19.9189 36.585C5.8542 36.5836 4.92961 36.5962 4.11258 36.306C4.01876 36.2727 3.92636 36.2354 3.81564 36.1936C2.06963 35.5346 0.710269 34.0133 0.178494 32.123C0.0407191 31.6333 0.00167899 31.2889 3.60194e-05 30.5491C-0.00238932 29.4734 0.117078 28.9093 0.536896 28.0124C0.892482 27.253 14.7495 3.05738 15.1805 2.44332ZM12 22C12 20.9 12.8975 20 13.9943 20C15.0912 20 15.9887 20.9 15.9887 22C15.9887 23.1 15.0912 24 13.9943 24C12.8975 24 12 23.1 12 22ZM23.966 22C23.966 20.9 24.8635 20 25.9604 20C27.0572 20 27.9547 20.9 27.9547 22C27.9547 23.1 27.0572 24 25.9604 24C24.8635 24 23.966 23.1 23.966 22ZM17.983 22C17.983 20.9 18.8805 20 19.9773 20C21.0742 20 21.9717 20.9 21.9717 22C21.9717 23.1 21.0742 24 19.9773 24C18.8805 24 17.983 23.1 17.983 22Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};
export const alignCenter: IconConfig = {
  width: 12,
  height: 14,
  paths: [
    {
      d: 'M6 0.333374C6.36667 0.333374 6.66667 0.633374 6.66667 1.00004V3.66671H11C11.5533 3.66671 12 4.11337 12 4.66671C12 5.22004 11.5533 5.66671 11 5.66671H6.66667V8.33337H9C9.55333 8.33337 10 8.78004 10 9.33337C10 9.88671 9.55333 10.3334 9 10.3334H6.66667V13C6.66667 13.3667 6.36667 13.6667 6 13.6667C5.63333 13.6667 5.33333 13.3667 5.33333 13V10.3334H3C2.44667 10.3334 2 9.88671 2 9.33337C2 8.78004 2.44667 8.33337 3 8.33337H5.33333V5.66671H1C0.446667 5.66671 0 5.22004 0 4.66671C0 4.11337 0.446667 3.66671 1 3.66671H5.33333V1.00004C5.33333 0.633374 5.63333 0.333374 6 0.333374Z',
    },
  ],
};
export const alignLeft: IconConfig = {
  width: 14,
  height: 14,
  paths: [
    {
      d: 'M0.999674 13.6667C0.633008 13.6667 0.333008 13.3667 0.333008 13V1.00004C0.333008 0.633374 0.633008 0.333374 0.999674 0.333374C1.36634 0.333374 1.66634 0.633374 1.66634 1.00004V13C1.66634 13.3667 1.36634 13.6667 0.999674 13.6667ZM12.6663 3.66671H3.99967C3.44634 3.66671 2.99967 4.11337 2.99967 4.66671C2.99967 5.22004 3.44634 5.66671 3.99967 5.66671H12.6663C13.2197 5.66671 13.6663 5.22004 13.6663 4.66671C13.6663 4.11337 13.2197 3.66671 12.6663 3.66671ZM8.66634 8.33337H3.99967C3.44634 8.33337 2.99967 8.78004 2.99967 9.33337C2.99967 9.88671 3.44634 10.3334 3.99967 10.3334H8.66634C9.21967 10.3334 9.66634 9.88671 9.66634 9.33337C9.66634 8.78004 9.21967 8.33337 8.66634 8.33337Z',
    },
  ],
};
export const alignRight: IconConfig = {
  width: 14,
  height: 14,
  paths: [
    {
      d: 'M12.9997 0.333374C13.3663 0.333374 13.6663 0.633374 13.6663 1.00004V13C13.6663 13.3667 13.3663 13.6667 12.9997 13.6667C12.633 13.6667 12.333 13.3667 12.333 13V1.00004C12.333 0.633374 12.633 0.333374 12.9997 0.333374ZM1.33301 5.66671H9.99967C10.553 5.66671 10.9997 5.22004 10.9997 4.66671C10.9997 4.11337 10.553 3.66671 9.99967 3.66671H1.33301C0.779674 3.66671 0.333008 4.11337 0.333008 4.66671C0.333008 5.22004 0.779674 5.66671 1.33301 5.66671ZM5.33301 10.3334H9.99967C10.553 10.3334 10.9997 9.88671 10.9997 9.33337C10.9997 8.78004 10.553 8.33337 9.99967 8.33337H5.33301C4.77967 8.33337 4.33301 8.78004 4.33301 9.33337C4.33301 9.88671 4.77967 10.3334 5.33301 10.3334Z',
    },
  ],
};
export const angleDown: IconConfig = {
  width: 12,
  height: 8,
  paths: [
    {
      d: 'M0.351471 0.751863C0.8201 0.283233 1.5799 0.283233 2.04853 0.751863L5.99999 4.70333L9.95146 0.751863C10.4201 0.283233 11.1799 0.283233 11.6485 0.751863C12.1171 1.22049 12.1171 1.98029 11.6485 2.44892L6.84852 7.24892C6.37989 7.71755 5.62009 7.71755 5.15146 7.24892L0.351471 2.44892C-0.117157 1.98029 -0.117157 1.22049 0.351471 0.751863Z',
    },
  ],
};
export const angleLeft: IconConfig = {
  width: 8,
  height: 12,
  paths: [
    {
      d: 'M6.70994 9.87998L2.82994 5.99998L6.70994 2.11998C7.09994 1.72998 7.09994 1.09998 6.70994 0.70998C6.31994 0.31998 5.68994 0.31998 5.29994 0.70998L0.709941 5.29998C0.319942 5.68998 0.319942 6.31998 0.709941 6.70998L5.29994 11.3C5.68994 11.69 6.31994 11.69 6.70994 11.3C7.08994 10.91 7.09994 10.27 6.70994 9.87998Z',
    },
  ],
};
export const angleRight: IconConfig = {
  width: 8,
  height: 12,
  paths: [
    {
      d: 'M1.29006 2.12002L5.17006 6.00002L1.29006 9.88002C0.900059 10.27 0.900059 10.9 1.29006 11.29C1.68006 11.68 2.31006 11.68 2.70006 11.29L7.29006 6.70002C7.68006 6.31002 7.68006 5.68002 7.29006 5.29002L2.70006 0.700021C2.31006 0.31002 1.68006 0.31002 1.29006 0.700021C0.910059 1.09002 0.900059 1.73002 1.29006 2.12002Z',
    },
  ],
};
export const angleUp: IconConfig = {
  width: 16,
  height: 10,
  paths: [
    {
      d: 'M13.1738 8.61317L8.00046 3.43984L2.82713 8.61317C2.30713 9.13317 1.46713 9.13317 0.947129 8.61317C0.427129 8.09317 0.427129 7.25317 0.947129 6.73317L7.06713 0.613174C7.58713 0.093174 8.42713 0.093174 8.94713 0.613174L15.0671 6.73317C15.5871 7.25317 15.5871 8.09317 15.0671 8.61317C14.5471 9.11984 13.6938 9.13317 13.1738 8.61317Z',
    },
  ],
};
export const arrowLeft: IconConfig = {
  width: 16,
  height: 16,
  paths: [
    {
      d: 'M8.525 15.4502C8.65833 15.3169 8.725 15.1419 8.725 14.9252C8.725 14.7085 8.65833 14.5335 8.525 14.4002L2.875 8.7502H15.25C15.4667 8.7502 15.6458 8.67936 15.7875 8.5377C15.9292 8.39603 16 8.21686 16 8.0002C16 7.78353 15.9292 7.60436 15.7875 7.4627C15.6458 7.32103 15.4667 7.2502 15.25 7.2502H2.875L8.525 1.6002C8.65833 1.46686 8.725 1.2877 8.725 1.0627C8.725 0.837695 8.65833 0.658529 8.525 0.525196C8.39167 0.391862 8.21667 0.325195 8 0.325195C7.78333 0.325195 7.60833 0.391862 7.475 0.525196L0.525 7.4752C0.441667 7.55853 0.383334 7.64186 0.35 7.7252C0.316667 7.80853 0.299999 7.9002 0.299999 8.0002C0.299999 8.08353 0.316667 8.17103 0.35 8.2627C0.383334 8.35436 0.441667 8.44186 0.525 8.5252L7.475 15.4752C7.60833 15.6085 7.78333 15.671 8 15.6627C8.21667 15.6544 8.39167 15.5835 8.525 15.4502Z',
    },
  ],
};
export const arrowRight: IconConfig = {
  width: 16,
  height: 16,
  paths: [
    {
      d: 'M7.475 15.4502C7.34167 15.3169 7.275 15.1419 7.275 14.9252C7.275 14.7085 7.34167 14.5335 7.475 14.4002L13.125 8.7502H0.75C0.533333 8.7502 0.354167 8.67936 0.2125 8.5377C0.0708334 8.39603 0 8.21686 0 8.0002C0 7.78353 0.0708334 7.60436 0.2125 7.4627C0.354167 7.32103 0.533333 7.2502 0.75 7.2502H13.125L7.475 1.6002C7.34167 1.46686 7.275 1.2877 7.275 1.0627C7.275 0.837695 7.34167 0.658529 7.475 0.525196C7.60833 0.391862 7.78333 0.325195 8 0.325195C8.21667 0.325195 8.39167 0.391862 8.525 0.525196L15.475 7.4752C15.5583 7.55853 15.6167 7.64186 15.65 7.7252C15.6833 7.80853 15.7 7.9002 15.7 8.0002C15.7 8.08353 15.6833 8.17103 15.65 8.2627C15.6167 8.35436 15.5583 8.44186 15.475 8.5252L8.525 15.4752C8.39167 15.6085 8.21667 15.671 8 15.6627C7.78333 15.6544 7.60833 15.5835 7.475 15.4502Z',
    },
  ],
};
export const barsDuo: IconConfig = {
  width: 16,
  height: 6,
  paths: [
    {
      d: 'M15 0H1C0.45 0 0 0.45 0 1C0 1.55 0.45 2 1 2H15C15.55 2 16 1.55 16 1C16 0.45 15.55 0 15 0ZM1 6H15C15.55 6 16 5.55 16 5C16 4.45 15.55 4 15 4H1C0.45 4 0 4.45 0 5C0 5.55 0.45 6 1 6Z',
    },
  ],
};
export const barsSolid: IconConfig = {
  width: 8,
  height: 16,
  paths: [
    {
      d: 'M16 0.5H2C0.9 0.5 0 1.4 0 2.5V6.5C0 7.6 0.9 8.5 2 8.5H16C17.1 8.5 18 7.6 18 6.5V2.5C18 1.4 17.1 0.5 16 0.5ZM4 6.5C2.9 6.5 2 5.6 2 4.5C2 3.4 2.9 2.5 4 2.5C5.1 2.5 6 3.4 6 4.5C6 5.6 5.1 6.5 4 6.5Z',
    },
    {
      d: 'M14.5 9.5H3.5C2.675 9.5 2 10.175 2 11V14C2 14.825 2.675 15.5 3.5 15.5H14.5C15.325 15.5 16 14.825 16 14V11C16 10.175 15.325 9.5 14.5 9.5ZM5 14C5.82843 14 6.5 13.3284 6.5 12.5C6.5 11.6716 5.82843 11 5 11C4.17157 11 3.5 11.6716 3.5 12.5C3.5 13.3284 4.17157 14 5 14Z',
    },
  ],
};
export const bars: IconConfig = {
  width: 18,
  height: 12,
  paths: [
    {
      d: 'M17 5H1C0.45 5 0 5.45 0 6C0 6.55 0.45 7 1 7H17C17.55 7 18 6.55 18 6C18 5.45 17.55 5 17 5ZM1 12H11C11.55 12 12 11.55 12 11C12 10.45 11.55 10 11 10H1C0.45 10 0 10.45 0 11C0 11.55 0.45 12 1 12ZM17 0H1C0.45 0 0 0.45 0 1V1.01C0 1.56 0.45 2.01 1 2.01H17C17.55 2.01 18 1.56 18 1.01V1C18 0.45 17.55 0 17 0Z',
    },
  ],
};
export const bell: IconConfig = {
  width: 22,
  height: 27,
  paths: [
    {
      d: 'M11.0002 26.3335C12.4668 26.3335 13.6668 25.1335 13.6668 23.6668H8.3335C8.3335 25.1335 9.52016 26.3335 11.0002 26.3335ZM19.0002 18.3335V11.6668C19.0002 7.5735 16.8135 4.14683 13.0002 3.24016V2.3335C13.0002 1.22683 12.1068 0.333496 11.0002 0.333496C9.8935 0.333496 9.00016 1.22683 9.00016 2.3335V3.24016C5.1735 4.14683 3.00016 7.56016 3.00016 11.6668V18.3335L0.333496 21.0002V22.3335H21.6668V21.0002L19.0002 18.3335Z',
    },
  ],
};
export const bold: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15.6 10.79C16.57 10.12 17.25 9.02 17.25 8C17.25 5.74 15.5 4 13.25 4H7V18H14.04C16.13 18 17.75 16.3 17.75 14.21C17.75 12.69 16.89 11.39 15.6 10.79V10.79ZM10 6.5H13C13.83 6.5 14.5 7.17 14.5 8C14.5 8.83 13.83 9.5 13 9.5H10V6.5ZM13.5 15.5H10V12.5H13.5C14.33 12.5 15 13.17 15 14C15 14.83 14.33 15.5 13.5 15.5Z',
    },
  ],
};
export const buildings: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M18.6667 10.6667V2.66667C18.6667 1.2 17.4667 0 16 0H8C6.53333 0 5.33333 1.2 5.33333 2.66667V5.33333H2.66667C1.2 5.33333 0 6.53333 0 8V21.3333C0 22.8 1.2 24 2.66667 24H9.33333C10.0667 24 10.6667 23.4 10.6667 22.6667V18.6667H13.3333V22.6667C13.3333 23.4 13.9333 24 14.6667 24H21.3333C22.8 24 24 22.8 24 21.3333V13.3333C24 11.8667 22.8 10.6667 21.3333 10.6667H18.6667ZM5.33333 21.3333H2.66667V18.6667H5.33333V21.3333ZM5.33333 16H2.66667V13.3333H5.33333V16ZM5.33333 10.6667H2.66667V8H5.33333V10.6667ZM10.6667 16H8V13.3333H10.6667V16ZM10.6667 10.6667H8V8H10.6667V10.6667ZM10.6667 5.33333H8V2.66667H10.6667V5.33333ZM16 16H13.3333V13.3333H16V16ZM16 10.6667H13.3333V8H16V10.6667ZM16 5.33333H13.3333V2.66667H16V5.33333ZM21.3333 21.3333H18.6667V18.6667H21.3333V21.3333ZM21.3333 16H18.6667V13.3333H21.3333V16Z',
    },
  ],
};
export const bus: IconConfig = {
  width: 18,
  height: 21,
  paths: [
    {
      d: 'M0 15.4737C0 16.4463 0.43875 17.3195 1.125 17.9274V19.3421C1.125 20.2595 1.87875 21 2.8125 21C3.74625 21 4.5 20.2595 4.5 19.3421V18.7895H13.5V19.3421C13.5 20.2484 14.2537 21 15.1875 21C16.11 21 16.875 20.2595 16.875 19.3421V17.9274C17.5613 17.3195 18 16.4463 18 15.4737V4.42105C18 0.552632 13.9725 0 9 0C4.0275 0 0 0.552632 0 4.42105V15.4737ZM3.9375 16.5789C3.00375 16.5789 2.25 15.8384 2.25 14.9211C2.25 14.0037 3.00375 13.2632 3.9375 13.2632C4.87125 13.2632 5.625 14.0037 5.625 14.9211C5.625 15.8384 4.87125 16.5789 3.9375 16.5789ZM14.0625 16.5789C13.1287 16.5789 12.375 15.8384 12.375 14.9211C12.375 14.0037 13.1287 13.2632 14.0625 13.2632C14.9963 13.2632 15.75 14.0037 15.75 14.9211C15.75 15.8384 14.9963 16.5789 14.0625 16.5789ZM15.75 9.94737H2.25V4.42105H15.75V9.94737Z',
    },
  ],
};
export const portfolio: IconConfig = {
  width: 24,
  height: 21,
  paths: [
    {
      d: 'M10.2 15.1122C9.86863 15.1122 9.6 14.8486 9.6 14.5235C9.6 14.1983 9.33137 13.9347 9 13.9347H1.212L1.2 18.6449C1.2 19.952 2.268 21 3.6 21H20.4C21.732 21 22.8 19.952 22.8 18.6449V13.9347H15C14.6686 13.9347 14.4 14.1983 14.4 14.5235C14.4 14.8486 14.1314 15.1122 13.8 15.1122H10.2ZM21.6 4.51429H17.688C17.1909 4.51429 16.788 4.11889 16.788 3.63113V1.76633C16.788 0.790811 15.9821 0 14.988 0H8.988C7.99389 0 7.188 0.790811 7.188 1.76633V3.63113C7.188 4.11889 6.78506 4.51429 6.288 4.51429H2.4C1.08 4.51429 0 5.57409 0 6.86939V10.402C0 11.7091 1.068 12.7571 2.4 12.7571H8.7C9.19706 12.7571 9.6 12.3617 9.6 11.874V11.2852C9.6 10.7975 10.0029 10.402 10.5 10.402H13.5C13.9971 10.402 14.4 10.7975 14.4 11.2852V11.874C14.4 12.3617 14.8029 12.7571 15.3 12.7571H21.6C22.92 12.7571 24 11.6974 24 10.402V6.86939C24 5.57409 22.92 4.51429 21.6 4.51429ZM14.4 3.63113C14.4 4.11889 13.9971 4.51429 13.5 4.51429H10.5C10.0029 4.51429 9.6 4.11889 9.6 3.63113V3.04235C9.6 2.5546 10.0029 2.15919 10.5 2.15919H13.5C13.9971 2.15919 14.4 2.5546 14.4 3.04235V3.63113Z',
    },
  ],
};
export const calendar: IconConfig = {
  width: 16,
  height: 18,
  paths: [
    {
      d: 'M14.4 1.6H13.6V0H12V1.6H4V0H2.4V1.6H1.6C0.72 1.6 0 2.32 0 3.2V16C0 16.88 0.72 17.6 1.6 17.6H14.4C15.28 17.6 16 16.88 16 16V3.2C16 2.32 15.28 1.6 14.4 1.6ZM14.4 16H1.6V5.6H14.4V16Z',
    },
  ],
};
export const camera: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M2.47034 6.87046C2.21876 7.18219 2.10391 7.55409 2 7.93145V16.0694C2.00365 16.0749 2.0079 16.0804 2.01215 16.0858C2.02066 16.0968 2.02917 16.1077 2.03281 16.1186C2.3008 17.3273 3.1321 18 4.37357 18H13.4303C13.5999 18 13.7749 18 13.9444 17.9672C15.0601 17.7594 15.7984 16.857 15.7984 15.6811C15.8039 13.231 15.8094 10.7754 15.793 8.31976C15.793 7.98068 15.7274 7.61972 15.5906 7.31345C15.1804 6.41652 14.4367 6.00087 13.4522 6.00087H5.54942C5.45549 6.00087 5.36134 6.00066 5.26705 6.00044C4.88925 5.99956 4.50934 5.99868 4.13293 6.01181C3.44383 6.03369 2.89693 6.33996 2.47034 6.87046ZM22.439 13.1434C22.4384 12.7624 22.4378 12.3816 22.4378 12.0008C22.4378 11.7207 22.4385 11.4402 22.4392 11.1596C22.4412 10.317 22.4433 9.47289 22.4269 8.63184C22.4214 8.38027 22.3667 8.10681 22.2464 7.88805C21.88 7.21536 21.0815 7.00206 20.4088 7.3849C19.8455 7.70484 19.2849 8.02888 18.7243 8.35292C18.1637 8.67696 17.6032 9.00101 17.0398 9.32095C16.925 9.39204 16.9141 9.47408 16.9141 9.58346C16.9195 11.1914 16.9195 12.7938 16.9141 14.3962C16.9141 14.5384 16.9578 14.6205 17.0836 14.6916C18.1665 15.3041 19.2439 15.9221 20.3213 16.5401C20.4471 16.6112 20.5838 16.6768 20.7205 16.7206C21.5792 16.9776 22.4323 16.3487 22.4378 15.4354C22.4415 14.6695 22.4402 13.906 22.439 13.1434Z',
    },
  ],
};
export const code: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M9.4 16.6L4.8 12L9.4 7.4L8 6L2 12L8 18L9.4 16.6ZM14.6 16.6L19.2 12L14.6 7.4L16 6L22 12L16 18L14.6 16.6Z',
    },
  ],
};
export const copy: IconConfig = {
  width: 16,
  height: 16,
  paths: [
    {
      d: 'M13.6667 9.66683V3.66683C13.6667 2.9335 13.0667 2.3335 12.3333 2.3335H6.33333C5.6 2.3335 5 2.9335 5 3.66683V9.66683C5 10.4002 5.6 11.0002 6.33333 11.0002H12.3333C13.0667 11.0002 13.6667 10.4002 13.6667 9.66683ZM12.3333 9.66683H6.33333V3.66683H12.3333V9.66683Z',
    },
    {
      d: 'M2.3999 6.40039C2.3999 5.84811 2.84762 5.40039 3.3999 5.40039H3.9999C4.33127 5.40039 4.5999 5.66902 4.5999 6.00039C4.5999 6.33176 4.33127 6.60039 3.9999 6.60039H3.5999V12.7337H9.3999V12.0004C9.3999 11.669 9.66853 11.4004 9.9999 11.4004C10.3313 11.4004 10.5999 11.669 10.5999 12.0004V12.9337C10.5999 13.486 10.1522 13.9337 9.5999 13.9337H4.3999C3.29533 13.9337 2.3999 13.0383 2.3999 11.9337V6.40039Z',
    },
  ],
};
export const check: IconConfig = {
  width: 18,
  height: 12,
  paths: [
    {
      d: 'M6.11909 11.6397C6.22206 11.6808 6.3329 11.7004 6.4498 11.7004C6.56671 11.7004 6.67755 11.6808 6.78051 11.6397C6.88762 11.5968 6.98745 11.5249 7.08087 11.4315L16.7059 1.80646C16.8834 1.6289 16.9748 1.41181 16.9748 1.16289C16.9748 0.913968 16.8834 0.696879 16.7059 0.519325C16.5283 0.341769 16.3112 0.250391 16.0623 0.250391C15.8134 0.250391 15.5963 0.341769 15.4187 0.519324L6.4498 9.48826L2.55587 5.59432C2.37963 5.41809 2.16719 5.32539 1.9248 5.32539C1.68242 5.32539 1.46998 5.41809 1.29374 5.59432C1.11494 5.77312 1.0248 5.99489 1.0248 6.25039C1.0248 6.50589 1.11494 6.72766 1.29374 6.90646L5.81874 11.4315C5.91216 11.5249 6.01199 11.5968 6.11909 11.6397Z',
    },
  ],
};
export const crop: IconConfig = {
  width: 16,
  height: 16,
  paths: [
    {
      d: 'M11.3334 10.0003H12.6667V4.66699C12.6667 3.93366 12.0667 3.33366 11.3334 3.33366H6.00008V4.66699H10.6667C11.0334 4.66699 11.3334 4.96699 11.3334 5.33366V10.0003ZM5.33342 11.3337C4.96675 11.3337 4.66675 11.0337 4.66675 10.667V1.33366C4.66675 0.966992 4.36675 0.666992 4.00008 0.666992C3.63341 0.666992 3.33341 0.966992 3.33341 1.33366V3.33366H1.33341C0.966748 3.33366 0.666748 3.63366 0.666748 4.00033C0.666748 4.36699 0.966748 4.66699 1.33341 4.66699H3.33341V11.3337C3.33341 12.067 3.93341 12.667 4.66675 12.667H11.3334V14.667C11.3334 15.0337 11.6334 15.3337 12.0001 15.3337C12.3667 15.3337 12.6667 15.0337 12.6667 14.667V12.667H14.6667C15.0334 12.667 15.3334 12.367 15.3334 12.0003C15.3334 11.6337 15.0334 11.3337 14.6667 11.3337H5.33342Z',
    },
  ],
};
export const cross: IconConfig = {
  width: 14,
  height: 14,
  paths: [
    {
      d: 'M1.85616 13.4057L7.0001 8.26174L12.144 13.4057C12.3203 13.5819 12.5327 13.6746 12.7751 13.6746C13.0175 13.6746 13.2299 13.5819 13.4062 13.4057C13.5824 13.2294 13.6751 13.017 13.6751 12.7746C13.6751 12.5322 13.5824 12.3198 13.4062 12.1435L8.26223 6.99961L13.4062 1.85568C13.5824 1.67944 13.6751 1.46699 13.6751 1.22461C13.6751 0.982226 13.5824 0.76978 13.4062 0.593543C13.2299 0.417307 13.0175 0.324609 12.7751 0.324609C12.5327 0.324609 12.3203 0.417307 12.144 0.593543L7.0001 5.73748L1.85616 0.593543C1.67993 0.417307 1.46748 0.324609 1.2251 0.324609C0.982715 0.324609 0.770268 0.417307 0.594032 0.593543C0.417795 0.76978 0.325098 0.982226 0.325098 1.22461C0.325098 1.46699 0.417795 1.67944 0.594032 1.85568L5.73797 6.99961L0.594032 12.1435C0.417795 12.3198 0.325098 12.5322 0.325098 12.7746C0.325098 13.017 0.417795 13.2294 0.594032 13.4057C0.770268 13.5819 0.982714 13.6746 1.2251 13.6746C1.46748 13.6746 1.67993 13.5819 1.85616 13.4057Z',
    },
  ],
};
export const crossFilled: IconConfig = {
  width: 14,
  height: 14,
  paths: [
    {
      d: 'M7.00004 0.333374C3.31337 0.333374 0.333374 3.31337 0.333374 7.00004C0.333374 10.6867 3.31337 13.6667 7.00004 13.6667C10.6867 13.6667 13.6667 10.6867 13.6667 7.00004C13.6667 3.31337 10.6867 0.333374 7.00004 0.333374ZM9.86671 9.86671C9.60671 10.1267 9.18671 10.1267 8.92671 9.86671L7.00004 7.94004L5.07337 9.86671C4.81337 10.1267 4.39337 10.1267 4.13337 9.86671C3.87337 9.60671 3.87337 9.18671 4.13337 8.92671L6.06004 7.00004L4.13337 5.07337C3.87337 4.81337 3.87337 4.39337 4.13337 4.13337C4.39337 3.87337 4.81337 3.87337 5.07337 4.13337L7.00004 6.06004L8.92671 4.13337C9.18671 3.87337 9.60671 3.87337 9.86671 4.13337C10.1267 4.39337 10.1267 4.81337 9.86671 5.07337L7.94004 7.00004L9.86671 8.92671C10.12 9.18004 10.12 9.60671 9.86671 9.86671Z',
    },
  ],
};
export const crossSearch: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      type: 'rect',
      width: 24,
      height: 24,
      rx: 12,
      fill: '#F6F6FA',
    },
    {
      d: 'M9.48087 15.2568L11.9998 12.7379L14.5187 15.2568C14.62 15.3581 14.7449 15.4133 14.8873 15.4133C15.0297 15.4133 15.1546 15.3581 15.2559 15.2568C15.3571 15.1556 15.4123 15.0307 15.4123 14.8883C15.4123 14.7459 15.3571 14.621 15.2559 14.5197L12.7369 12.0008L15.2559 9.48185C15.3571 9.38061 15.4123 9.25566 15.4123 9.11328C15.4123 8.9709 15.3571 8.84595 15.2559 8.74472C15.1546 8.64348 15.0297 8.58828 14.8873 8.58828C14.7449 8.58828 14.62 8.64348 14.5187 8.74472L11.9998 11.2636L9.48087 8.74472C9.37963 8.64348 9.25469 8.58828 9.1123 8.58828C8.96992 8.58828 8.84498 8.64348 8.74374 8.74472C8.6425 8.84595 8.5873 8.9709 8.5873 9.11328C8.5873 9.25566 8.6425 9.38061 8.74374 9.48185L11.2627 12.0008L8.74374 14.5197C8.6425 14.621 8.5873 14.7459 8.5873 14.8883C8.5873 15.0307 8.6425 15.1556 8.74374 15.2568C8.84498 15.3581 8.96992 15.4133 9.1123 15.4133C9.25469 15.4133 9.37963 15.3581 9.48087 15.2568Z',
      stroke: 0.3,
      strokeColor: '#040D61',
    },
  ],
};
export const dashboard: IconConfig = {
  width: 32,
  height: 32,
  paths: [
    {
      d: 'M13 28H8.33333C7.05 28 6 26.95 6 25.6667V9.33333C6 8.05 7.05 7 8.33333 7H13C14.2833 7 15.3333 8.05 15.3333 9.33333V25.6667C15.3333 26.95 14.2833 28 13 28ZM20 28H24.6667C25.95 28 27 26.95 27 25.6667V19.8333C27 18.55 25.95 17.5 24.6667 17.5H20C18.7167 17.5 17.6667 18.55 17.6667 19.8333V25.6667C17.6667 26.95 18.7167 28 20 28ZM27 12.8333V9.33333C27 8.05 25.95 7 24.6667 7H20C18.7167 7 17.6667 8.05 17.6667 9.33333V12.8333C17.6667 14.1167 18.7167 15.1667 20 15.1667H24.6667C25.95 15.1667 27 14.1167 27 12.8333Z',
    },
  ],
};
export const dotsTriangle: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17.3333 5.33333C17.3333 8.28 14.9467 10.6667 12 10.6667C9.05333 10.6667 6.66667 8.28 6.66667 5.33333C6.66667 2.38667 9.05333 0 12 0C14.9467 0 17.3333 2.38667 17.3333 5.33333ZM5.33333 13.3333C2.38667 13.3333 0 15.72 0 18.6667C0 21.6133 2.38667 24 5.33333 24C8.28 24 10.6667 21.6133 10.6667 18.6667C10.6667 15.72 8.28 13.3333 5.33333 13.3333ZM18.6667 13.3333C15.72 13.3333 13.3333 15.72 13.3333 18.6667C13.3333 21.6133 15.72 24 18.6667 24C21.6133 24 24 21.6133 24 18.6667C24 15.72 21.6133 13.3333 18.6667 13.3333Z',
    },
  ],
};
export const dots: IconConfig = {
  width: 16,
  height: 4,
  paths: [
    {
      d: 'M1.99434 0C0.897452 0 0 0.9 0 2C0 3.1 0.897452 4 1.99434 4C3.09122 4 3.98867 3.1 3.98867 2C3.98867 0.9 3.09122 0 1.99434 0ZM13.9604 0C12.8635 0 11.966 0.9 11.966 2C11.966 3.1 12.8635 4 13.9604 4C15.0572 4 15.9547 3.1 15.9547 2C15.9547 0.9 15.0572 0 13.9604 0ZM7.97735 0C6.88046 0 5.98301 0.9 5.98301 2C5.98301 3.1 6.88046 4 7.97735 4C9.07423 4 9.97169 3.1 9.97169 2C9.97169 0.9 9.07423 0 7.97735 0Z',
    },
  ],
};
export const dotsList: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M4 10.5C3.17 10.5 2.5 11.17 2.5 12C2.5 12.83 3.17 13.5 4 13.5C4.83 13.5 5.5 12.83 5.5 12C5.5 11.17 4.83 10.5 4 10.5ZM4 4.5C3.17 4.5 2.5 5.17 2.5 6C2.5 6.83 3.17 7.5 4 7.5C4.83 7.5 5.5 6.83 5.5 6C5.5 5.17 4.83 4.5 4 4.5ZM4 16.5C3.17 16.5 2.5 17.18 2.5 18C2.5 18.82 3.18 19.5 4 19.5C4.82 19.5 5.5 18.82 5.5 18C5.5 17.18 4.83 16.5 4 16.5ZM7 19H21V17H7V19ZM7 13H21V11H7V13ZM7 5V7H21V5H7Z',
    },
  ],
};
export const drops: IconConfig = {
  width: 35,
  height: 40,
  paths: [
    {
      d: 'M29.0053 1.28991C27.3074 3.57579 26.1118 5.60888 25.6949 6.91947C25.2106 8.44172 25.5959 10.0864 26.7148 11.2723C28.1264 12.7684 30.1971 13.1509 32.0603 12.2597C33.1927 11.7181 34.1545 10.5329 34.4714 9.28897C34.6246 8.68715 34.6231 7.79172 34.4678 7.18136C34.3343 6.65712 33.6661 5.20563 33.2052 4.43879C32.3171 2.9612 30.2031 0 30.0364 0C29.9963 0 29.5322 0.580502 29.0053 1.28991ZM4.87205 3.70446C2.5871 6.75194 0.986179 9.42328 0.259141 11.4016C0.0117541 12.0749 0 12.1566 0 13.2039C0 14.1862 0.0220194 14.3666 0.2104 14.9279C1.05811 17.4545 3.42267 19.0773 6.05914 18.9419C8.59766 18.8116 10.6428 17.2013 11.4058 14.732C11.5528 14.2563 11.5875 13.965 11.5879 13.2039C11.5883 12.3435 11.5665 12.2003 11.3308 11.5191C10.8347 10.0851 9.88154 8.31901 8.44306 6.16877C7.82024 5.23768 6.35198 3.214 5.94458 2.72494L5.76662 2.51133L4.87205 3.70446ZM18.4712 11.4604C16.0057 14.6901 13.3275 18.7003 11.7176 21.5728C9.55258 25.4359 8.64178 28.0804 8.76175 30.1547C8.9162 32.8245 9.92432 35.069 11.8161 36.955C13.0636 38.1987 14.299 38.9764 15.846 39.4917C17.0602 39.8963 17.7355 40 19.1531 40C20.5706 40 21.2461 39.8963 22.4597 39.4919C25.0645 38.6241 27.4083 36.5399 28.5472 34.0785C29.2538 32.5513 29.5196 31.3764 29.5203 29.7774C29.5208 28.7629 29.4955 28.5446 29.2839 27.74C28.3419 24.1574 25.1453 18.5822 20.354 12.1656C19.7346 11.3359 19.1954 10.6572 19.156 10.6572C19.1166 10.6572 18.8085 11.0186 18.4712 11.4604Z',
    },
  ],
};
export const eye: IconConfig = {
  width: 20,
  height: 13,
  paths: [
    {
      d: 'M10.0002 0.333984C5.8335 0.333984 2.27516 2.92565 0.833496 6.58398C2.27516 10.2423 5.8335 12.834 10.0002 12.834C14.1668 12.834 17.7252 10.2423 19.1668 6.58398C17.7252 2.92565 14.1668 0.333984 10.0002 0.333984ZM10.0002 10.7507C7.70016 10.7507 5.8335 8.88398 5.8335 6.58398C5.8335 4.28398 7.70016 2.41732 10.0002 2.41732C12.3002 2.41732 14.1668 4.28398 14.1668 6.58398C14.1668 8.88398 12.3002 10.7507 10.0002 10.7507ZM10.0002 4.08398C8.61683 4.08398 7.50016 5.20065 7.50016 6.58398C7.50016 7.96732 8.61683 9.08398 10.0002 9.08398C11.3835 9.08398 12.5002 7.96732 12.5002 6.58398C12.5002 5.20065 11.3835 4.08398 10.0002 4.08398Z',
    },
  ],
};
export const emergencyRequest: IconConfig = {
  width: 32,
  height: 32,
  paths: [
    {
      d: 'M19.0719 6.77354C17.7066 4.40882 14.2934 4.40882 12.9281 6.77354L4.48051 21.4053C3.11524 23.77 4.82183 26.7259 7.55238 26.7259H24.4476C27.1782 26.7259 28.8848 23.77 27.5195 21.4053L24.9784 17.0039L19.5087 15.7811L18.9616 20.7675L14.6669 19.6655L11.7633 23.1318L13.0021 17.5905L16.7419 18.0008L17.4258 11.7678L22.6265 12.9304L19.0719 6.77354Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};
export const fileBucket: IconConfig = {
  width: 36,
  height: 36,
  paths: [
    {
      d: 'M35.0457 14.6766L35.0363 14.6391L29.7769 1.275C29.5425 0.520312 28.8441 0 28.0519 0H6.73316C5.93629 0 5.22848 0.529688 5.00348 1.29375L0.0862889 14.5219L0.072227 14.5547L0.0628514 14.5922C0.00191392 14.8219 -0.0168361 15.0562 0.0159764 15.2859C0.0112889 15.3609 0.00660156 15.4359 0.00660156 15.5109V32.6625C0.00784108 33.418 0.308506 34.1422 0.842716 34.6764C1.37693 35.2106 2.10112 35.5113 2.8566 35.5125H32.2566C33.8269 35.5125 35.1066 34.2328 35.1113 32.6625V15.5109C35.1113 15.45 35.1113 15.3891 35.1066 15.3375C35.1254 15.1078 35.1066 14.8875 35.0457 14.6766ZM21.18 12.6609L21.166 13.3969C21.1285 15.5016 19.6754 16.9172 17.5519 16.9172C16.516 16.9172 15.6254 16.5844 14.9832 15.9516C14.341 15.3187 13.9894 14.4375 13.9707 13.3969L13.9566 12.6609H4.30973L8.03629 3.6H26.7488L30.5785 12.6609H21.18ZM3.60191 16.2609H10.9754C12.1144 18.9375 14.5379 20.5172 17.5566 20.5172C19.1363 20.5172 20.6035 20.0766 21.7894 19.2422C22.83 18.5109 23.641 17.4891 24.166 16.2609H31.5019V31.9125H3.60191V16.2609Z',
    },
  ],
};
export const fileDownload: IconConfig = {
  width: 12,
  height: 12,
  paths: [
    {
      d: 'M9.99984 8.00033V10.0003H1.99984V8.00033H0.666504V10.0003C0.666504 10.7337 1.2665 11.3337 1.99984 11.3337H9.99984C10.7332 11.3337 11.3332 10.7337 11.3332 10.0003V8.00033H9.99984ZM9.33317 5.33366L8.39317 4.39366L6.6665 6.11366V0.666992H5.33317V6.11366L3.6065 4.39366L2.6665 5.33366L5.99984 8.66699L9.33317 5.33366Z',
    },
  ],
};
export const fileUpload: IconConfig = {
  width: 12,
  height: 12,
  paths: [
    {
      d: 'M4.25 2.96905H5.40469V8.25499C5.40469 8.32374 5.46094 8.37999 5.52969 8.37999H6.46719C6.53594 8.37999 6.59219 8.32374 6.59219 8.25499V2.96905H7.75C7.85469 2.96905 7.9125 2.84874 7.84844 2.76749L6.09844 0.551867C6.08674 0.536927 6.0718 0.524844 6.05475 0.516534C6.03769 0.508225 6.01897 0.503906 6 0.503906C5.98103 0.503906 5.96231 0.508225 5.94525 0.516534C5.92819 0.524844 5.91326 0.536927 5.90156 0.551867L4.15156 2.76593C4.0875 2.84874 4.14531 2.96905 4.25 2.96905ZM11.7188 7.78624H10.7812C10.7125 7.78624 10.6562 7.84249 10.6562 7.91124V10.3175H1.34375V7.91124C1.34375 7.84249 1.2875 7.78624 1.21875 7.78624H0.28125C0.2125 7.78624 0.15625 7.84249 0.15625 7.91124V11.005C0.15625 11.2816 0.379687 11.505 0.65625 11.505H11.3438C11.6203 11.505 11.8438 11.2816 11.8438 11.005V7.91124C11.8438 7.84249 11.7875 7.78624 11.7188 7.78624Z',
    },
  ],
};
export const file: IconConfig = {
  width: 20,
  height: 24,
  paths: [
    {
      d: 'M13.2375 0.708C12.7625 0.252 12.125 0 11.4625 0H2.5C1.125 0 0 1.08 0 2.4V21.6C0 22.92 1.1125 24 2.4875 24H17.5C18.875 24 20 22.92 20 21.6V8.196C20 7.56 19.7375 6.948 19.2625 6.504L13.2375 0.708ZM13.75 19.2H6.25C5.5625 19.2 5 18.66 5 18C5 17.34 5.5625 16.8 6.25 16.8H13.75C14.4375 16.8 15 17.34 15 18C15 18.66 14.4375 19.2 13.75 19.2ZM13.75 14.4H6.25C5.5625 14.4 5 13.86 5 13.2C5 12.54 5.5625 12 6.25 12H13.75C14.4375 12 15 12.54 15 13.2C15 13.86 14.4375 14.4 13.75 14.4ZM11.25 7.2V1.8L18.125 8.4H12.5C11.8125 8.4 11.25 7.86 11.25 7.2Z',
    },
  ],
};
export const fileAdd: IconConfig = {
  width: 16,
  height: 22,
  paths: [
    {
      d: 'M10.59 0.59C10.21 0.21 9.7 0 9.17 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6.83C16 6.3 15.79 5.79 15.41 5.42L10.59 0.59ZM11 14H9V16C9 16.55 8.55 17 8 17C7.45 17 7 16.55 7 16V14H5C4.45 14 4 13.55 4 13C4 12.45 4.45 12 5 12H7V10C7 9.45 7.45 9 8 9C8.55 9 9 9.45 9 10V12H11C11.55 12 12 12.45 12 13C12 13.55 11.55 14 11 14ZM9 6V1.5L14.5 7H10C9.45 7 9 6.55 9 6Z',
    },
  ],
};
export const files: IconConfig = {
  width: 30,
  height: 26,
  paths: [
    {
      d: 'M24.3335 23.3333H3.00016V7.33333C3.00016 6.6 2.40016 6 1.66683 6C0.933496 6 0.333496 6.6 0.333496 7.33333V23.3333C0.333496 24.8 1.5335 26 3.00016 26H24.3335C25.0668 26 25.6668 25.4 25.6668 24.6667C25.6668 23.9333 25.0668 23.3333 24.3335 23.3333Z',
    },
    {
      d: 'M27.0003 3.33334H17.667L15.787 1.45334C15.2803 0.946672 14.6003 0.666672 13.8937 0.666672H8.33366C6.86699 0.666672 5.68033 1.86667 5.68033 3.33334L5.66699 18C5.66699 19.4667 6.86699 20.6667 8.33366 20.6667H27.0003C28.467 20.6667 29.667 19.4667 29.667 18V6.00001C29.667 4.53334 28.467 3.33334 27.0003 3.33334ZM23.0003 15.3333H12.3337C11.787 15.3333 11.467 14.7067 11.8003 14.2667L13.6403 11.8267C13.907 11.4667 14.4403 11.4667 14.707 11.8267L16.3337 14L19.2937 10.04C19.5603 9.68001 20.0937 9.68001 20.3603 10.04L23.5337 14.2667C23.867 14.7067 23.547 15.3333 23.0003 15.3333Z',
    },
  ],
};
export const folders: IconConfig = {
  width: 30,
  height: 26,
  paths: [
    {
      d: 'M24.3335 23.3333H3.00016V7.33333C3.00016 6.6 2.40016 6 1.66683 6C0.933496 6 0.333496 6.6 0.333496 7.33333V23.3333C0.333496 24.8 1.5335 26 3.00016 26H24.3335C25.0668 26 25.6668 25.4 25.6668 24.6667C25.6668 23.9333 25.0668 23.3333 24.3335 23.3333Z',
    },
    {
      d: 'M27.0003 3.33334H17.667L15.787 1.45334C15.2803 0.946672 14.6003 0.666672 13.8937 0.666672H8.33366C6.86699 0.666672 5.68033 1.86667 5.68033 3.33334L5.66699 18C5.66699 19.4667 6.86699 20.6667 8.33366 20.6667H27.0003C28.467 20.6667 29.667 19.4667 29.667 18V6.00001C29.667 4.53334 28.467 3.33334 27.0003 3.33334Z',
    },
  ],
};
export const filter: IconConfig = {
  width: 28,
  height: 12,
  paths: [
    {
      d: 'M8 12H10C10.55 12 11 11.55 11 11C11 10.45 10.55 10 10 10H8C7.45 10 7 10.45 7 11C7 11.55 7.45 12 8 12ZM0 1C0 1.55 0.45 2 1 2H17C17.55 2 18 1.55 18 1C18 0.45 17.55 0 17 0H1C0.45 0 0 0.45 0 1ZM4 7H14C14.55 7 15 6.55 15 6C15 5.45 14.55 5 14 5H4C3.45 5 3 5.45 3 6C3 6.55 3.45 7 4 7Z',
    },
  ],
};
export const fire: IconConfig = {
  width: 29,
  height: 40,
  paths: [
    {
      d: 'M11.5502 0.111901C11.5248 0.178184 11.5487 0.569548 11.6031 0.981548C11.8188 2.61071 11.5729 4.39682 10.9323 5.85363C10.1749 7.57651 9.35859 8.66806 6.51931 11.755C4.71608 13.7155 4.18441 14.3337 3.43318 15.3439C1.95738 17.3286 1.05107 19.1377 0.507991 21.1834C0.0743408 22.8167 0.000476318 23.452 7.33705e-06 25.5508C-0.00038348 27.3329 0.0141551 27.5339 0.209251 28.4474C1.47909 34.3931 6.10543 38.8563 11.9922 39.8149C19.9345 41.1081 27.429 35.4853 28.6082 27.3486C28.77 26.2321 28.7257 23.8 28.5228 22.6588C28.0728 20.1277 27.2113 17.9298 25.914 16.0028C25.1202 14.8237 24.8519 14.7665 24.8815 15.7827C24.9376 17.7005 23.7715 19.2096 21.9783 19.54C21.3127 19.6627 20.5858 19.5503 19.918 19.2215C19.3243 18.9293 18.5921 18.1744 18.274 17.5264C18.0605 17.0917 18.0503 17.0219 18.0574 16.054C18.0633 15.2479 18.1163 14.7797 18.3135 13.7889C18.6233 12.233 18.679 11.4547 18.5629 10.3089C18.3813 8.51877 17.9993 7.20773 17.2191 5.6973C16.1551 3.63723 14.4131 1.71761 12.3345 0.314345C11.8241 -0.0301997 11.6245 -0.0817094 11.5502 0.111901ZM12.6537 19.814C12.7227 19.883 12.7629 19.9974 12.743 20.068C12.6493 20.4011 12.6148 22.4716 12.69 23.2476C12.8538 24.9379 13.2439 25.8693 14.1786 26.8028C15.1515 27.7742 16.2141 28.178 17.62 28.1103C18.7217 28.0573 19.5752 27.7152 20.5344 26.9422C20.8138 26.7171 20.9717 26.8054 21.1515 27.2874C21.5619 28.3875 21.6586 30.107 21.3768 31.2933C20.7414 33.9689 18.6628 36.0823 16.0176 36.7423C15.0573 36.982 13.4894 36.9812 12.5953 36.7406C9.97608 36.0358 7.99441 34.0338 7.33228 31.4235C7.1794 30.8207 7.1461 30.4913 7.1461 29.58C7.1461 26.845 7.94446 24.7433 9.91199 22.2987C10.544 21.5135 12.3111 19.685 12.4361 19.6871C12.4868 19.6879 12.5847 19.745 12.6537 19.814Z',
    },
  ],
};
export const gear: IconConfig = {
  width: 26,
  height: 28,
  paths: [
    {
      d: 'M22.9996 14.0003C22.9996 13.6937 22.9862 13.4003 22.9596 13.0937L25.4396 11.2137C25.9729 10.8137 26.1196 10.067 25.7862 9.48033L23.2929 5.17366C22.9596 4.58699 22.2396 4.34699 21.6262 4.61366L18.7596 5.82699C18.2662 5.48033 17.7462 5.17366 17.1996 4.92033L16.8129 1.84033C16.7329 1.17366 16.1596 0.666992 15.4929 0.666992H10.5196C9.83955 0.666992 9.26622 1.17366 9.18622 1.84033L8.79955 4.92033C8.25289 5.17366 7.73289 5.48033 7.23955 5.82699L4.37289 4.61366C3.75955 4.34699 3.03955 4.58699 2.70622 5.17366L0.212887 9.49366C-0.120446 10.0803 0.0262202 10.8137 0.559554 11.227L3.03955 13.107C3.01289 13.4003 2.99955 13.6937 2.99955 14.0003C2.99955 14.307 3.01289 14.6003 3.03955 14.907L0.559554 16.787C0.0262202 17.187 -0.120446 17.9337 0.212887 18.5203L2.70622 22.827C3.03955 23.4137 3.75955 23.6537 4.37289 23.387L7.23955 22.1737C7.73289 22.5203 8.25289 22.827 8.79955 23.0803L9.18622 26.1603C9.26622 26.827 9.83955 27.3337 10.5062 27.3337H15.4796C16.1462 27.3337 16.7196 26.827 16.7996 26.1603L17.1862 23.0803C17.7329 22.827 18.2529 22.5203 18.7462 22.1737L21.6129 23.387C22.2262 23.6537 22.9462 23.4137 23.2796 22.827L25.7729 18.5203C26.1062 17.9337 25.9596 17.2003 25.4262 16.787L22.9462 14.907C22.9862 14.6003 22.9996 14.307 22.9996 14.0003ZM13.0529 18.667C10.4796 18.667 8.38622 16.5737 8.38622 14.0003C8.38622 11.427 10.4796 9.33366 13.0529 9.33366C15.6262 9.33366 17.7196 11.427 17.7196 14.0003C17.7196 16.5737 15.6262 18.667 13.0529 18.667Z',
    },
  ],
};
export const groupAdd: IconConfig = {
  width: 30,
  height: 17,
  paths: [
    {
      d: 'M0.803571 17C0.571429 17 0.379464 16.9224 0.227679 16.7673C0.0758929 16.6122 0 16.416 0 16.1787V14.4267C0 13.788 0.160714 13.2085 0.482143 12.6884C0.803571 12.1683 1.25 11.7805 1.82143 11.525C3.125 10.941 4.29911 10.5212 5.34375 10.2657C6.38839 10.0102 7.46429 9.88245 8.57143 9.88245C9.67857 9.88245 10.75 10.0102 11.7857 10.2657C12.8214 10.5212 13.9911 10.941 15.2946 11.525C15.8661 11.7805 16.317 12.1683 16.6473 12.6884C16.9777 13.2085 17.1429 13.788 17.1429 14.4267V16.1787C17.1429 16.416 17.067 16.6122 16.9152 16.7673C16.7634 16.9224 16.5714 17 16.3393 17H0.803571ZM18.1607 17C18.3393 16.9635 18.4821 16.8677 18.5893 16.7126C18.6964 16.5574 18.75 16.3612 18.75 16.124V14.4267C18.75 13.277 18.4643 12.3325 17.8929 11.5934C17.3214 10.8543 16.5714 10.2566 15.6429 9.80032C16.875 9.94632 18.0357 10.1608 19.125 10.4436C20.2143 10.7265 21.0982 11.0505 21.7768 11.4155C22.3661 11.7622 22.8304 12.1911 23.1696 12.7021C23.5089 13.2131 23.6786 13.788 23.6786 14.4267V16.1787C23.6786 16.416 23.6027 16.6122 23.4509 16.7673C23.2991 16.9224 23.1071 17 22.875 17H18.1607ZM8.57143 8.21256C7.39286 8.21256 6.42857 7.82931 5.67857 7.0628C4.92857 6.2963 4.55357 5.31079 4.55357 4.10628C4.55357 2.90177 4.92857 1.91626 5.67857 1.14976C6.42857 0.383253 7.39286 0 8.57143 0C9.75 0 10.7143 0.383253 11.4643 1.14976C12.2143 1.91626 12.5893 2.90177 12.5893 4.10628C12.5893 5.31079 12.2143 6.2963 11.4643 7.0628C10.7143 7.82931 9.75 8.21256 8.57143 8.21256ZM18.2143 4.10628C18.2143 5.31079 17.8393 6.2963 17.0893 7.0628C16.3393 7.82931 15.375 8.21256 14.1964 8.21256C14 8.21256 13.7812 8.19887 13.5402 8.1715C13.2991 8.14412 13.0804 8.09394 12.8839 8.02094C13.3125 7.56468 13.6384 7.00349 13.8616 6.33736C14.0848 5.67123 14.1964 4.92754 14.1964 4.10628C14.1964 3.28502 14.0848 2.55958 13.8616 1.92995C13.6384 1.30032 13.3125 0.720881 12.8839 0.191627C13.0804 0.136876 13.2991 0.0912509 13.5402 0.0547506C13.7812 0.0182503 14 0 14.1964 0C15.375 0 16.3393 0.383253 17.0893 1.14976C17.8393 1.91626 18.2143 2.90177 18.2143 4.10628Z',
    },
    {
      d: 'M25.1385 10.1973C25.2903 10.3524 25.4823 10.43 25.7144 10.43C25.9466 10.43 26.1385 10.3524 26.2903 10.1973C26.4421 10.0422 26.518 9.84598 26.518 9.60873V6.87121H29.1966C29.4287 6.87121 29.6207 6.79365 29.7725 6.63852C29.9242 6.4834 30.0001 6.28721 30.0001 6.04995C30.0001 5.8127 29.9242 5.61651 29.7725 5.46139C29.6207 5.30626 29.4287 5.2287 29.1966 5.2287H26.518V2.49118C26.518 2.25393 26.4421 2.05774 26.2903 1.90261C26.1385 1.74749 25.9466 1.66992 25.7144 1.66992C25.4823 1.66992 25.2903 1.74749 25.1385 1.90261C24.9867 2.05774 24.9109 2.25393 24.9109 2.49118V5.2287H22.2323C22.0001 5.2287 21.8082 5.30626 21.6564 5.46139C21.5046 5.61651 21.4287 5.8127 21.4287 6.04995C21.4287 6.28721 21.5046 6.4834 21.6564 6.63852C21.8082 6.79365 22.0001 6.87121 22.2323 6.87121H24.9109V9.60873C24.9109 9.84598 24.9867 10.0422 25.1385 10.1973Z',
    },
  ],
};
export const group: IconConfig = {
  width: 28,
  height: 16,
  paths: [
    {
      d: 'M14.0003 8C15.9322 8 17.6388 8.46222 19.0255 9.06667C20.3055 9.63556 21.1114 10.9156 21.1114 12.3022V15.1111H6.88921V12.3141C6.88921 10.9156 7.69514 9.63556 8.97514 9.07852C10.3618 8.46222 12.0685 8 14.0003 8ZM5.40773 8.2963C6.71144 8.2963 7.7781 7.22963 7.7781 5.92593C7.7781 4.62222 6.71144 3.55556 5.40773 3.55556C4.10403 3.55556 3.03736 4.62222 3.03736 5.92593C3.03736 7.22963 4.10403 8.2963 5.40773 8.2963ZM6.74699 9.6C6.30847 9.52889 5.86996 9.48148 5.40773 9.48148C4.2344 9.48148 3.12033 9.73037 2.11292 10.1689C1.23588 10.5481 0.666992 11.4015 0.666992 12.3615V15.1111H6.00033V12.3141C6.00033 11.3304 6.27292 10.4059 6.74699 9.6ZM22.5929 8.2963C23.8966 8.2963 24.9633 7.22963 24.9633 5.92593C24.9633 4.62222 23.8966 3.55556 22.5929 3.55556C21.2892 3.55556 20.2225 4.62222 20.2225 5.92593C20.2225 7.22963 21.2892 8.2963 22.5929 8.2963ZM27.3337 12.3615C27.3337 11.4015 26.7648 10.5481 25.8877 10.1689C24.8803 9.73037 23.7663 9.48148 22.5929 9.48148C22.1307 9.48148 21.6922 9.52889 21.2537 9.6C21.7277 10.4059 22.0003 11.3304 22.0003 12.3141V15.1111H27.3337V12.3615ZM14.0003 0C15.9677 0 17.5559 1.58815 17.5559 3.55556C17.5559 5.52296 15.9677 7.11111 14.0003 7.11111C12.0329 7.11111 10.4448 5.52296 10.4448 3.55556C10.4448 1.58815 12.0329 0 14.0003 0Z',
    },
  ],
};
export const global: IconConfig = {
  width: 28,
  height: 16,
  paths: [
    {
      d: 'M8.00016 1.33301C4.32016 1.33301 1.3335 4.31967 1.3335 7.99967C1.3335 11.6797 4.32016 14.6663 8.00016 14.6663C11.6802 14.6663 14.6668 11.6797 14.6668 7.99967C14.6668 4.31967 11.6802 1.33301 8.00016 1.33301ZM7.3335 13.2863C4.70016 12.9597 2.66683 10.7197 2.66683 7.99967C2.66683 7.58634 2.72016 7.19301 2.80683 6.80634L6.00016 9.99967V10.6663C6.00016 11.3997 6.60016 11.9997 7.3335 11.9997V13.2863ZM11.9335 11.593C11.7602 11.053 11.2668 10.6663 10.6668 10.6663H10.0002V8.66634C10.0002 8.29967 9.70016 7.99967 9.3335 7.99967H5.3335V6.66634H6.66683C7.0335 6.66634 7.3335 6.36634 7.3335 5.99967V4.66634H8.66683C9.40016 4.66634 10.0002 4.06634 10.0002 3.33301V3.05967C11.9535 3.85301 13.3335 5.76634 13.3335 7.99967C13.3335 9.38634 12.8002 10.6463 11.9335 11.593Z',
    },
  ],
};
export const h: IconConfig = {
  width: 12,
  height: 14,
  paths: [
    {
      d: 'M1.26807 14C0.567733 14 0 13.4323 0 12.7319V1.26807C0 0.567733 0.567733 0 1.26807 0C1.9684 0 2.53613 0.567733 2.53613 1.26807V5.92676H9.02344V1.27148C9.02344 0.569263 9.5927 0 10.2949 0C10.9971 0 11.5664 0.569263 11.5664 1.27148V12.7285C11.5664 13.4307 10.9971 14 10.2949 14C9.5927 14 9.02344 13.4307 9.02344 12.7285V8.05274H2.53613V12.7319C2.53613 13.4323 1.9684 14 1.26807 14Z',
    },
  ],
};
export const heading1 = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M5.77778 4H18.2222C19.2 4 20 4.8 20 5.77778V18.2222C20 19.2 19.2 20 18.2222 20H5.77778C4.8 20 4 19.2 4 18.2222V5.77778C4 4.8 4.8 4 5.77778 4ZM12.8889 14.6667H11.5556V10.6667H10.2222V9.33333H12.8889V14.6667Z',
    },
  ],
};
export const heading2 = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M5.77778 4H18.2222C19.2 4 20 4.8 20 5.77778V18.2222C20 19.2 19.2 20 18.2222 20H5.77778C4.8 20 4 19.2 4 18.2222V5.77778C4 4.8 4.8 4 5.77778 4ZM13.3333 12.4444H11.5556V13.3333H14.2222V14.6667H10.2222V12.4444C10.2222 11.9556 10.6222 11.5556 11.1111 11.5556H12.8889V10.6667H10.2222V9.33333H13.3333C13.8222 9.33333 14.2222 9.73333 14.2222 10.2222V11.5556C14.2222 12.0444 13.8222 12.4444 13.3333 12.4444Z',
    },
  ],
};
export const history: IconConfig = {
  width: 22,
  height: 19,
  paths: [
    {
      d: 'M12.26 1.00007C7.17003 0.860072 3.00003 4.95007 3.00003 10.0001H1.21003C0.760031 10.0001 0.540031 10.5401 0.860031 10.8501L3.65003 13.6501C3.85003 13.8501 4.16003 13.8501 4.36003 13.6501L7.15003 10.8501C7.46003 10.5401 7.24003 10.0001 6.79003 10.0001H5.00003C5.00003 6.10007 8.18003 2.95007 12.1 3.00007C15.82 3.05007 18.95 6.18007 19 9.90007C19.05 13.8101 15.9 17.0001 12 17.0001C10.39 17.0001 8.90003 16.4501 7.72003 15.5201C7.32003 15.2101 6.76003 15.2401 6.40003 15.6001C5.98003 16.0201 6.01003 16.7301 6.48003 17.0901C8.00003 18.2901 9.91003 19.0001 12 19.0001C17.05 19.0001 21.14 14.8301 21 9.74007C20.87 5.05007 16.95 1.13007 12.26 1.00007ZM11.75 6.00007C11.34 6.00007 11 6.34007 11 6.75007V10.4301C11 10.7801 11.19 11.1101 11.49 11.2901L14.61 13.1401C14.97 13.3501 15.43 13.2301 15.64 12.8801C15.85 12.5201 15.73 12.0601 15.38 11.8501L12.5 10.1401V6.74007C12.5 6.34007 12.16 6.00007 11.75 6.00007Z',
    },
  ],
};
export const houseBroken: IconConfig = {
  width: 28,
  height: 25,
  paths: [
    {
      d: 'M13.0663 1.02925C13.595 0.545589 14.4056 0.545589 14.9343 1.02925L27.3337 12.3706H23.8607V23.3554C23.8607 24.1197 23.2411 24.7393 22.4767 24.7393H14.7237L17.806 19.8956L13.4237 16.2628L18.325 12.4571L15.2401 9.97758L15.8455 6.31599L12.2127 9.97758L15.2401 12.4571L9.09895 16.1187L13.7985 20.5299L9.80774 24.7393H5.52385C4.75954 24.7393 4.13994 24.1197 4.13994 23.3554V12.3706H0.666992L13.0663 1.02925Z',
    },
  ],
};
export const quote: IconConfig = {
  width: 28,
  height: 25,
  paths: [
    {
      d: 'M6 17H9L11 13V7H5V13H8L6 17ZM14 17H17L19 13V7H13V13H16L14 17Z',
    },
  ],
};
export const image: IconConfig = {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M18 16V2C18 0.9 17.1 0 16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16ZM5.9 10.98L8 13.51L11.1 9.52C11.3 9.26 11.7 9.26 11.9 9.53L15.41 14.21C15.66 14.54 15.42 15.01 15.01 15.01H3.02C2.6 15.01 2.37 14.53 2.63 14.2L5.12 11C5.31 10.74 5.69 10.73 5.9 10.98Z',
    },
  ],
};
export const info: IconConfig = {
  width: 14,
  height: 14,
  paths: [
    {
      d: 'M7.05016 10.433C7.21874 10.433 7.36439 10.3769 7.47921 10.2621C7.59403 10.1472 7.65016 10.0016 7.65016 9.83301V6.81634C7.65016 6.65453 7.58811 6.51463 7.46883 6.40197C7.35091 6.29061 7.20991 6.23301 7.05016 6.23301C6.88158 6.23301 6.73594 6.28914 6.62112 6.40396C6.5063 6.51878 6.45016 6.66443 6.45016 6.83301V9.84967C6.45016 10.0115 6.51221 10.1514 6.6315 10.264C6.74941 10.3754 6.89042 10.433 7.05016 10.433ZM7.00016 5.19967C7.17934 5.19967 7.3351 5.14117 7.4606 5.02227C7.5876 4.90196 7.65016 4.74721 7.65016 4.56634C7.65016 4.38558 7.58783 4.22747 7.46433 4.09747C7.33958 3.96615 7.18266 3.89967 7.00016 3.89967C6.81766 3.89967 6.66075 3.96615 6.536 4.09747C6.41249 4.22747 6.35016 4.38558 6.35016 4.56634C6.35016 4.74721 6.41273 4.90196 6.53972 5.02227C6.66523 5.14117 6.82098 5.19967 7.00016 5.19967ZM4.32828 13.2503C5.15249 13.5946 6.04348 13.7663 7.00016 13.7663C7.9459 13.7663 8.83131 13.5946 9.65538 13.2503C10.4781 12.9065 11.1947 12.4299 11.8042 11.8204C12.4136 11.211 12.8929 10.4946 13.2422 9.67209C13.5923 8.84775 13.7668 7.95657 13.7668 6.99967C13.7668 6.05372 13.5922 5.16812 13.2422 4.34392C12.8929 3.52146 12.4136 2.80505 11.8042 2.19563C11.1948 1.58621 10.4784 1.10689 9.65592 0.75763C8.83172 0.407629 7.94612 0.233008 7.00016 0.233008C6.04326 0.233008 5.15208 0.407567 4.32774 0.75763C3.50528 1.10689 2.78888 1.58621 2.17945 2.19563C1.56991 2.80518 1.09329 3.52176 0.749559 4.34446C0.405258 5.16852 0.233496 6.05393 0.233496 6.99967C0.233496 7.95636 0.405198 8.84735 0.749559 9.67156C1.09329 10.4943 1.56991 11.2108 2.17945 11.8204C2.789 12.4299 3.50559 12.9065 4.32828 13.2503ZM10.9295 10.929C9.83688 12.0215 8.52889 12.5663 7.00016 12.5663C5.47143 12.5663 4.16344 12.0215 3.07087 10.929C1.9783 9.83639 1.4335 8.52841 1.4335 6.99967C1.4335 5.47094 1.9783 4.16296 3.07087 3.07038C4.16344 1.97781 5.47143 1.43301 7.00016 1.43301C8.52889 1.43301 9.83688 1.97781 10.9295 3.07038C12.022 4.16296 12.5668 5.47094 12.5668 6.99967C12.5668 8.52841 12.022 9.83639 10.9295 10.929Z',
    },
  ],
};
export const italic: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M10 4V7H12.21L8.79 15H6V18H14V15H11.79L15.21 7H18V4H10Z',
    },
  ],
};
export const labelFilled: IconConfig = {
  width: 14,
  height: 18,
  paths: [
    {
      d: 'M12 0H2C0.9 0 0 0.9 0 2V18L7 15L14 18V2C14 0.9 13.1 0 12 0Z',
    },
  ],
};
export const label: IconConfig = {
  width: 14,
  height: 18,
  paths: [
    {
      outline: true,
      stroke: 2,
      d: 'M7.39392 14.0809L7 13.912L6.60608 14.0809L1 16.4835V2C1 1.45228 1.45228 1 2 1H12C12.5477 1 13 1.45228 13 2V16.4835L7.39392 14.0809Z',
    },
  ],
};
export const letter: IconConfig = {
  width: 16,
  height: 12,
  paths: [
    {
      d: 'M0.00300002 1.884L8 5.882L15.997 1.884C15.9674 1.37444 15.7441 0.895488 15.3728 0.545227C15.0016 0.194965 14.5104 -9.35847e-05 14 3.36834e-08H2C1.48958 -9.35847e-05 0.998447 0.194965 0.627178 0.545227C0.255908 0.895488 0.0326041 1.37444 0.00300002 1.884Z',
    },
    {
      d: 'M16 4.118L8 8.118L0 4.118V10C0 10.5304 0.210714 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12H14C14.5304 12 15.0391 11.7893 15.4142 11.4142C15.7893 11.0391 16 10.5304 16 10V4.118Z',
    },
  ],
};
export const linkAngle: IconConfig = {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M8.99967 1.92856L6.87835 4.04988C6.48944 4.43879 6.48944 5.07518 6.87835 5.46409C7.26726 5.853 7.90365 5.853 8.29256 5.46409L10.4139 3.34277C11.5806 2.17605 13.4898 2.17605 14.6565 3.34277C15.8233 4.5095 15.8233 6.41869 14.6565 7.58541L12.5352 9.70673C12.1463 10.0956 12.1463 10.732 12.5352 11.1209C12.9241 11.5099 13.5605 11.5099 13.9494 11.1209L16.0707 8.99962C18.0224 7.04801 18.0224 3.88017 16.0707 1.92856C14.1191 -0.0230547 10.9513 -0.0230545 8.99967 1.92856ZM6.17124 11.828C6.56015 12.217 7.19655 12.217 7.58546 11.828L11.8281 7.58541C12.217 7.1965 12.217 6.56011 11.8281 6.1712C11.4392 5.78229 10.8028 5.78229 10.4139 6.1712L6.17124 10.4138C5.78233 10.8027 5.78233 11.4391 6.17124 11.828ZM9.70678 12.5352L7.58546 14.6565C6.41873 15.8232 4.50954 15.8232 3.34281 14.6565C2.17609 13.4897 2.17609 11.5806 3.34281 10.4138L5.46414 8.29252C5.85304 7.90361 5.85304 7.26721 5.46414 6.8783C5.07523 6.4894 4.43883 6.4894 4.04992 6.8783L1.9286 8.99962C-0.0230141 10.9512 -0.0230142 14.1191 1.9286 16.0707C3.88022 18.0223 7.04805 18.0223 8.99967 16.0707L11.121 13.9494C11.5099 13.5605 11.5099 12.9241 11.121 12.5352C10.7321 12.1462 10.0957 12.1462 9.70678 12.5352Z',
    },
  ],
};
export const link: IconConfig = {
  width: 20,
  height: 10,
  paths: [
    {
      d: 'M15 0H12C11.45 0 11 0.45 11 1C11 1.55 11.45 2 12 2H15C16.65 2 18 3.35 18 5C18 6.65 16.65 8 15 8H12C11.45 8 11 8.45 11 9C11 9.55 11.45 10 12 10H15C17.76 10 20 7.76 20 5C20 2.24 17.76 0 15 0ZM6 5C6 5.55 6.45 6 7 6H13C13.55 6 14 5.55 14 5C14 4.45 13.55 4 13 4H7C6.45 4 6 4.45 6 5ZM8 8H5C3.35 8 2 6.65 2 5C2 3.35 3.35 2 5 2H8C8.55 2 9 1.55 9 1C9 0.45 8.55 0 8 0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10H8C8.55 10 9 9.55 9 9C9 8.45 8.55 8 8 8Z',
    },
  ],
};
export const list: IconConfig = {
  width: 18,
  height: 14,
  paths: [
    {
      d: 'M1.5 8.5H2.5C3.05 8.5 3.5 8.05 3.5 7.5V6.5C3.5 5.95 3.05 5.5 2.5 5.5H1.5C0.95 5.5 0.5 5.95 0.5 6.5V7.5C0.5 8.05 0.95 8.5 1.5 8.5ZM1.5 13.5H2.5C3.05 13.5 3.5 13.05 3.5 12.5V11.5C3.5 10.95 3.05 10.5 2.5 10.5H1.5C0.95 10.5 0.5 10.95 0.5 11.5V12.5C0.5 13.05 0.95 13.5 1.5 13.5ZM1.5 3.5H2.5C3.05 3.5 3.5 3.05 3.5 2.5V1.5C3.5 0.95 3.05 0.5 2.5 0.5H1.5C0.95 0.5 0.5 0.95 0.5 1.5V2.5C0.5 3.05 0.95 3.5 1.5 3.5ZM5.5 8.5H16.5C17.05 8.5 17.5 8.05 17.5 7.5V6.5C17.5 5.95 17.05 5.5 16.5 5.5H5.5C4.95 5.5 4.5 5.95 4.5 6.5V7.5C4.5 8.05 4.95 8.5 5.5 8.5ZM5.5 13.5H16.5C17.05 13.5 17.5 13.05 17.5 12.5V11.5C17.5 10.95 17.05 10.5 16.5 10.5H5.5C4.95 10.5 4.5 10.95 4.5 11.5V12.5C4.5 13.05 4.95 13.5 5.5 13.5ZM4.5 1.5V2.5C4.5 3.05 4.95 3.5 5.5 3.5H16.5C17.05 3.5 17.5 3.05 17.5 2.5V1.5C17.5 0.95 17.05 0.5 16.5 0.5H5.5C4.95 0.5 4.5 0.95 4.5 1.5Z',
    },
  ],
};
export const grid: IconConfig = {
  width: 16,
  height: 16,
  paths: [
    {
      d: 'M0 3C0 3.55228 0.447715 4 1 4H3C3.55228 4 4 3.55228 4 3V1C4 0.447715 3.55228 0 3 0H1C0.447715 0 0 0.447715 0 1V3ZM6 15C6 15.5523 6.44772 16 7 16H9C9.55229 16 10 15.5523 10 15V13C10 12.4477 9.55229 12 9 12H7C6.44772 12 6 12.4477 6 13V15ZM0 15C0 15.5523 0.447715 16 1 16H3C3.55228 16 4 15.5523 4 15V13C4 12.4477 3.55228 12 3 12H1C0.447715 12 0 12.4477 0 13V15ZM0 9C0 9.55229 0.447715 10 1 10H3C3.55228 10 4 9.55229 4 9V7C4 6.44772 3.55228 6 3 6H1C0.447715 6 0 6.44772 0 7V9ZM6 9C6 9.55229 6.44772 10 7 10H9C9.55229 10 10 9.55229 10 9V7C10 6.44772 9.55229 6 9 6H7C6.44772 6 6 6.44772 6 7V9ZM13 0C12.4477 0 12 0.447715 12 1V3C12 3.55228 12.4477 4 13 4H15C15.5523 4 16 3.55228 16 3V1C16 0.447715 15.5523 0 15 0H13ZM6 3C6 3.55228 6.44772 4 7 4H9C9.55229 4 10 3.55228 10 3V1C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1V3ZM12 9C12 9.55229 12.4477 10 13 10H15C15.5523 10 16 9.55229 16 9V7C16 6.44772 15.5523 6 15 6H13C12.4477 6 12 6.44772 12 7V9ZM12 15C12 15.5523 12.4477 16 13 16H15C15.5523 16 16 15.5523 16 15V13C16 12.4477 15.5523 12 15 12H13C12.4477 12 12 12.4477 12 13V15Z',
    },
  ],
};
export const notificationAlert: IconConfig = {
  width: 12,
  height: 12,
  paths: [
    {
      d: 'M8.21333 0H3.78667C3.61333 0 3.44 0.0733333 3.32 0.193333L0.193333 3.32C0.0733333 3.44 0 3.61333 0 3.78667V8.20667C0 8.38667 0.0733333 8.55333 0.193333 8.68L3.31333 11.8C3.44 11.9267 3.61333 12 3.78667 12H8.20667C8.38667 12 8.55333 11.9267 8.68 11.8067L11.8 8.68667C11.9267 8.56 11.9933 8.39333 11.9933 8.21333V3.78667C11.9933 3.60667 11.92 3.44 11.8 3.31333L8.68 0.193333C8.56 0.0733333 8.38667 0 8.21333 0ZM6 9.53333C5.52 9.53333 5.13333 9.14667 5.13333 8.66667C5.13333 8.18667 5.52 7.8 6 7.8C6.48 7.8 6.86667 8.18667 6.86667 8.66667C6.86667 9.14667 6.48 9.53333 6 9.53333ZM6 6.66667C5.63333 6.66667 5.33333 6.36667 5.33333 6V3.33333C5.33333 2.96667 5.63333 2.66667 6 2.66667C6.36667 2.66667 6.66667 2.96667 6.66667 3.33333V6C6.66667 6.36667 6.36667 6.66667 6 6.66667Z',
    },
  ],
};
export const notificationCheck: IconConfig = {
  width: 16,
  height: 14,
  paths: [
    {
      d: 'M15.3332 7L13.7065 5.14L13.9332 2.68L11.5265 2.13333L10.2665 0L7.99984 0.973333L5.73317 0L4.47317 2.12667L2.0665 2.66667L2.29317 5.13333L0.666504 7L2.29317 8.86L2.0665 11.3267L4.47317 11.8733L5.73317 14L7.99984 13.02L10.2665 13.9933L11.5265 11.8667L13.9332 11.32L13.7065 8.86L15.3332 7ZM6.7265 10.1467L4.19317 7.60667L5.17984 6.62L6.7265 8.17333L10.6265 4.26L11.6132 5.24667L6.7265 10.1467Z',
    },
  ],
};
export const numericList: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M2 17H4V17.5H3V18.5H4V19H2V20H5V16H2V17ZM3 8H4V4H2V5H3V8ZM2 11H3.8L2 13.1V14H5V13H3.2L5 10.9V10H2V11ZM7 5V7H21V5H7ZM7 19H21V17H7V19ZM7 13H21V11H7V13Z',
    },
  ],
};
export const pen: IconConfig = {
  width: 13,
  height: 13,
  paths: [
    {
      d: 'M0 10.64V12.6666C0 12.8533 0.146667 13 0.333333 13H2.36C2.44667 13 2.53333 12.9666 2.59333 12.9L9.87333 5.62662L7.37333 3.12662L0.1 10.4C0.0333334 10.4666 0 10.5466 0 10.64ZM11.8067 3.69329C12.0667 3.43329 12.0667 3.01329 11.8067 2.75329L10.2467 1.19329C9.98667 0.933291 9.56667 0.933291 9.30667 1.19329L8.08667 2.41329L10.5867 4.91329L11.8067 3.69329Z',
    },
  ],
};
export const phone: IconConfig = {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M16.23 12.2598L13.69 11.9698C13.08 11.8998 12.48 12.1098 12.05 12.5398L10.21 14.3798C7.38004 12.9398 5.06004 10.6298 3.62004 7.78977L5.47004 5.93976C5.90004 5.50977 6.11004 4.90977 6.04004 4.29977L5.75004 1.77977C5.63004 0.769766 4.78004 0.00976562 3.76004 0.00976562H2.03004C0.900041 0.00976562 -0.0399593 0.949766 0.0300407 2.07977C0.560041 10.6198 7.39004 17.4398 15.92 17.9698C17.05 18.0398 17.99 17.0998 17.99 15.9698V14.2398C18 13.2298 17.24 12.3798 16.23 12.2598Z',
    },
  ],
};
export const pin: IconConfig = {
  width: 12,
  height: 14,
  paths: [
    {
      d: 'M5.99984 0.333252C3.19984 0.333252 0.666504 2.47992 0.666504 5.79992C0.666504 7.91992 2.29984 10.4133 5.55984 13.2866C5.81317 13.5066 6.19317 13.5066 6.4465 13.2866C9.69984 10.4133 11.3332 7.91992 11.3332 5.79992C11.3332 2.47992 8.79984 0.333252 5.99984 0.333252ZM5.99984 6.99992C5.2665 6.99992 4.6665 6.39992 4.6665 5.66658C4.6665 4.93325 5.2665 4.33325 5.99984 4.33325C6.73317 4.33325 7.33317 4.93325 7.33317 5.66658C7.33317 6.39992 6.73317 6.99992 5.99984 6.99992Z',
    },
  ],
};
export const property: IconConfig = {
  width: 26,
  height: 20,
  paths: [
    {
      d: 'M1.61487 8.28936C1.08928 8.66478 0.777344 9.27092 0.777344 9.91682V17.9987C0.777344 19.1033 1.67277 19.9987 2.77734 19.9987H4.3329C5.43747 19.9987 6.3329 19.1033 6.3329 17.9987V13.332H10.7773V17.9987C10.7773 19.1033 11.6728 19.9987 12.7773 19.9987H14.3329C15.4375 19.9987 16.3329 19.1033 16.3329 17.9987V9.91682C16.3329 9.27092 16.021 8.66478 15.4954 8.28936L9.7176 4.16237C9.0222 3.66566 8.08804 3.66566 7.39264 4.16237L1.61487 8.28936Z',
    },
    {
      d: 'M11.2773 0C11.0012 0 10.7773 0.223858 10.7773 0.5V1.93158C10.7773 2.09306 10.8553 2.24459 10.9867 2.33845L18.3457 7.59489C18.4771 7.68874 18.5551 7.84028 18.5551 8.00175V8.38889C18.5551 8.66503 18.779 8.88889 19.0551 8.88889H20.2773C20.5535 8.88889 20.7773 9.11275 20.7773 9.38889V10.6111C20.7773 10.8873 20.5535 11.1111 20.2773 11.1111H19.0551C18.779 11.1111 18.5551 11.335 18.5551 11.6111V12.8333C18.5551 13.1095 18.779 13.3333 19.0551 13.3333H20.2773C20.5535 13.3333 20.7773 13.5572 20.7773 13.8333V15.0556C20.7773 15.3317 20.5535 15.5556 20.2773 15.5556H19.0551C18.779 15.5556 18.5551 15.7794 18.5551 16.0556V19.5C18.5551 19.7761 18.779 20 19.0551 20H24.7218C24.9979 20 25.2218 19.7761 25.2218 19.5V0.5C25.2218 0.223857 24.9979 0 24.7218 0H11.2773ZM20.7773 6.16667C20.7773 6.44281 20.5535 6.66667 20.2773 6.66667H19.0551C18.779 6.66667 18.5551 6.44281 18.5551 6.16667V4.94444C18.5551 4.6683 18.779 4.44444 19.0551 4.44444H20.2773C20.5535 4.44444 20.7773 4.6683 20.7773 4.94444V6.16667Z',
    },
  ],
};
export const play: IconConfig = {
  width: 40,
  height: 40,
  paths: [
    {
      d: 'M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM16 29V11L28 20L16 29Z',
    },
  ],
};
export const lplus: IconConfig = {
  width: 16,
  height: 16,
  paths: [
    {
      d: 'M11.9997 8.66665H8.66634V12C8.66634 12.3666 8.36634 12.6666 7.99967 12.6666C7.63301 12.6666 7.33301 12.3666 7.33301 12V8.66665H3.99967C3.63301 8.66665 3.33301 8.36665 3.33301 7.99998C3.33301 7.63331 3.63301 7.33331 3.99967 7.33331H7.33301V3.99998C7.33301 3.63331 7.63301 3.33331 7.99967 3.33331C8.36634 3.33331 8.66634 3.63331 8.66634 3.99998V7.33331H11.9997C12.3663 7.33331 12.6663 7.63331 12.6663 7.99998C12.6663 8.36665 12.3663 8.66665 11.9997 8.66665Z',
    },
  ],
};
export const rectangleBig: IconConfig = {
  width: 20,
  height: 20,
  paths: [
    {
      d: 'M1 3C1 1.89543 1.89543 1 3 1H17C18.1046 1 19 1.89543 19 3V17C19 18.1046 18.1046 19 17 19H3C1.89543 19 1 18.1046 1 17V3Z',
      stroke: 1,
      outline: true,
    },
  ],
};
export const rectangleMiddle: IconConfig = {
  width: 20,
  height: 16,
  paths: [
    {
      d: 'M1 3C1 1.89543 1.89543 1 3 1H17C18.1046 1 19 1.89543 19 3V13C19 14.1046 18.1046 15 17 15H3C1.89543 15 1 14.1046 1 13V3Z',
      stroke: 1,
      outline: true,
    },
  ],
};
export const rectangleSmall: IconConfig = {
  width: 20,
  height: 12,
  paths: [
    {
      d: 'M1 3C1 1.89543 1.89543 1 3 1H17C18.1046 1 19 1.89543 19 3V9C19 10.1046 18.1046 11 17 11H3C1.89543 11 1 10.1046 1 9V3Z',
      stroke: 1,
      outline: true,
    },
  ],
};
export const revert: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15.7 6.66145H7.05308C6.35328 6.66145 5.78072 7.23402 5.78072 7.93382C5.78072 8.63362 6.35328 9.20618 7.05308 9.20618H15.7V11.4837C15.7 12.0563 16.3871 12.3362 16.7815 11.929L20.3187 8.37915C20.5604 8.12467 20.5604 7.73024 20.3187 7.47577L16.7815 3.92587C16.3871 3.51871 15.7 3.81135 15.7 4.37119L15.7 6.66145ZM3.68131 16.5581L7.23121 20.108C7.62565 20.5151 8.31272 20.2352 8.31272 19.6626V17.3851H16.9596C17.6594 17.3851 18.232 16.8125 18.232 16.1127C18.232 15.4129 17.6594 14.8404 16.9596 14.8404H8.31272V12.5628C8.31272 11.9903 7.62565 11.7104 7.23121 12.1175L3.68131 15.6674C3.43956 15.9092 3.43956 16.3163 3.68131 16.5581Z',
    },
  ],
};
export const revertLeft: IconConfig = {
  width: 16,
  height: 17,
  paths: [
    {
      d: 'M4.66667 4.5C5.03333 4.5 5.33333 4.8 5.33333 5.16667V11.8333C5.33333 12.2 5.03333 12.5 4.66667 12.5C4.3 12.5 4 12.2 4 11.8333V5.16667C4 4.8 4.3 4.5 4.66667 4.5ZM7.10667 9.04667L10.9533 11.76C11.3933 12.0733 12.0067 11.7533 12.0067 11.2133V5.78667C12.0067 5.24667 11.4 4.93333 10.9533 5.24L7.10667 7.95333C6.72667 8.22 6.72667 8.78 7.10667 9.04667Z',
    },
  ],
};
export const revertRight: IconConfig = {
  width: 16,
  height: 17,
  paths: [
    {
      d: 'M5.05333 11.76L8.9 9.04667C9.27333 8.78 9.27333 8.22 8.9 7.96L5.05333 5.24C4.60667 4.93333 4 5.24667 4 5.78667V11.2133C4 11.7533 4.60667 12.0667 5.05333 11.76ZM10.6667 5.16667V11.8333C10.6667 12.2 10.9667 12.5 11.3333 12.5C11.7 12.5 12 12.2 12 11.8333V5.16667C12 4.8 11.7 4.5 11.3333 4.5C10.9667 4.5 10.6667 4.8 10.6667 5.16667Z',
    },
  ],
};
export const questionmark: IconConfig = {
  width: 20,
  height: 20,
  paths: [
    {
      d: 'M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 17H9V15H11V17ZM13.07 9.25L12.17 10.17C11.67 10.68 11.31 11.14 11.13 11.86C11.05 12.18 11 12.54 11 13H9V12.5C9 12.04 9.08 11.6 9.22 11.19C9.42 10.61 9.75 10.09 10.17 9.67L11.41 8.41C11.87 7.97 12.09 7.31 11.96 6.61C11.83 5.89 11.27 5.28 10.57 5.08C9.46 4.77 8.43 5.4 8.1 6.35C7.98 6.72 7.67 7 7.28 7H6.98C6.4 7 6 6.44 6.16 5.88C6.59 4.41 7.84 3.29 9.39 3.05C10.91 2.81 12.36 3.6 13.26 4.85C14.44 6.48 14.09 8.23 13.07 9.25Z',
    },
  ],
};
export const rotateLeft: IconConfig = {
  width: 32,
  height: 32,
  paths: [
    {
      d: 'm3.9 14.2c0-0.6 0.4-1 1-1h15.9c0.6 0 1 0.4 1 1v12.4c0 0.6-0.4 1-1 1h-15.9c-0.6 0-1-0.4-1-1zm2.3 11.2h13.3v-9.9h-13.3z',
    },
    {
      d: 'm25.3 10.4c-2.4-3-5.9-4.6-9.5-4.6v-2c0-0.2-0.3-0.3-0.4-0.2l-3.9 3.1c-0.1 0.1-0.1 0.3 0 0.4l3.9 3c0.1 0.2 0.4 0.1 0.4-0.1v-2q0.6 0 1.2 0.1 1.9 0.2 3.6 1.2 1.7 0.9 2.9 2.5 1.3 1.6 1.8 3.5 0.5 1.9 0.3 3.8-0.1 0.3-0.1 0.5h2.3c0.4-3.1-0.4-6.5-2.5-9.2z',
    },
  ],
};
export const rotateRight: IconConfig = {
  width: 32,
  height: 32,
  paths: [
    {
      d: 'm15 7.8q0.6 0 1.2 0v2c0 0.2 0.3 0.3 0.4 0.2l4-3.2c0.2-0.1 0.2-0.3 0-0.4l-4-3.1c-0.1-0.2-0.4-0.1-0.4 0.1v2c-3.7 0.1-7.3 1.7-9.8 4.9-2.2 2.8-3 6.2-2.5 9.4h2.3q0-0.2-0.1-0.5-0.2-2 0.3-3.9 0.5-2 1.8-3.6 1.3-1.6 3.1-2.6 1.7-1 3.7-1.3z',
    },
    {
      d: 'm10 14.1c0-0.6 0.4-1 1-1h16.5c0.6 0 1 0.4 1 1v12.9c0 0.6-0.4 1-1 1h-16.5c-0.6 0-1-0.4-1-1zm2.4 11.6h13.7v-10.2h-13.7z',
    },
  ],
};
export const search: IconConfig = {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M12.5001 11.0001H11.7101L11.4301 10.7301C12.6301 9.33014 13.2501 7.42014 12.9101 5.39014C12.4401 2.61014 10.1201 0.390137 7.32014 0.0501373C3.09014 -0.469863 -0.469863 3.09014 0.0501373 7.32014C0.390137 10.1201 2.61014 12.4401 5.39014 12.9101C7.42014 13.2501 9.33014 12.6301 10.7301 11.4301L11.0001 11.7101V12.5001L15.2501 16.7501C15.6601 17.1601 16.3301 17.1601 16.7401 16.7501C17.1501 16.3401 17.1501 15.6701 16.7401 15.2601L12.5001 11.0001ZM6.50014 11.0001C4.01014 11.0001 2.00014 8.99014 2.00014 6.50014C2.00014 4.01014 4.01014 2.00014 6.50014 2.00014C8.99014 2.00014 11.0001 4.01014 11.0001 6.50014C11.0001 8.99014 8.99014 11.0001 6.50014 11.0001Z',
    },
  ],
};
export const textAlignLeft: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15 15H3V17H15V15ZM15 7H3V9H15V7ZM3 13H21V11H3V13ZM3 21H21V19H3V21ZM3 3V5H21V3H3Z',
    },
  ],
};
export const textAlignCenter: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M7 15V17H17V15H7ZM3 21H21V19H3V21ZM3 13H21V11H3V13ZM7 7V9H17V7H7ZM3 3V5H21V3H3Z',
    },
  ],
};
export const textAlignRight: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M3 21H21V19H3V21ZM9 17H21V15H9V17ZM3 13H21V11H3V13ZM9 9H21V7H9V9ZM3 3V5H21V3H3Z',
    },
  ],
};
export const textAlignJustify: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M3 21H21V19H3V21ZM3 17H21V15H3V17ZM3 13H21V11H3V13ZM3 9H21V7H3V9ZM3 3V5H21V3H3Z',
    },
  ],
};
export const time: IconConfig = {
  width: 14,
  height: 14,
  paths: [
    {
      d: 'M6.9935 0.333252C3.3135 0.333252 0.333496 3.31992 0.333496 6.99992C0.333496 10.6799 3.3135 13.6666 6.9935 13.6666C10.6802 13.6666 13.6668 10.6799 13.6668 6.99992C13.6668 3.31992 10.6802 0.333252 6.9935 0.333252ZM7.00016 12.3333C4.0535 12.3333 1.66683 9.94659 1.66683 6.99992C1.66683 4.05325 4.0535 1.66659 7.00016 1.66659C9.94683 1.66659 12.3335 4.05325 12.3335 6.99992C12.3335 9.94659 9.94683 12.3333 7.00016 12.3333ZM6.8535 3.66659H6.8135C6.54683 3.66659 6.3335 3.87992 6.3335 4.14659V7.29325C6.3335 7.52659 6.4535 7.74659 6.66016 7.86659L9.42683 9.52659C9.6535 9.65992 9.94683 9.59325 10.0802 9.36659C10.2202 9.13992 10.1468 8.83992 9.9135 8.70659L7.3335 7.17325V4.14659C7.3335 3.87992 7.12016 3.66659 6.8535 3.66659Z',
    },
  ],
};
export const timeFilled: IconConfig = {
  width: 16,
  height: 16,
  paths: [
    {
      d: 'M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.36 11.36L7.2 8.8V4H8.4V8.16L12 10.32L11.36 11.36Z',
    },
  ],
};
export const toxic: IconConfig = {
  width: 40,
  height: 38,
  paths: [
    {
      d: 'M18.1247 0.0836904C15.8715 0.2992 13.524 0.944319 11.5661 1.88603C10.651 2.32621 10.5982 2.36475 10.3722 2.75895C10.1852 3.08492 10.1355 3.2651 10.1349 3.61911C10.1342 4.0481 10.2173 4.23321 12.1224 8.0472C14.2803 12.3672 14.3648 12.4997 15.0831 12.6932C15.5386 12.8158 15.8654 12.759 16.6252 12.4249C18.8006 11.4684 21.2091 11.4684 23.3845 12.4249C24.1443 12.759 24.4711 12.8158 24.9265 12.6932C25.6449 12.4997 25.7294 12.3672 27.8873 8.0472C29.773 4.27214 29.8755 4.04426 29.8755 3.62969C29.8755 3.119 29.6075 2.54799 29.2404 2.27662C28.9329 2.04929 27.2706 1.33257 26.3503 1.03057C23.7054 0.162577 20.7983 -0.172085 18.1247 0.0836904ZM18.9081 15.1614C17.0776 15.5546 15.4943 17.1524 15.1086 18.9957C14.3645 22.552 17.5062 25.6936 21.0624 24.9496C23.3125 24.4787 25.0158 22.3692 25.0158 20.0533C25.0158 18.2037 23.9084 16.4044 22.274 15.5988C21.1896 15.0642 20.0501 14.9162 18.9081 15.1614ZM5.64138 19.2332C3.36423 19.3747 1.38547 19.5121 1.24407 19.5387C0.898286 19.6036 0.377804 19.9917 0.214703 20.3063C-0.00448833 20.7293 -0.0401324 21.046 0.0373445 21.8816C0.398016 25.7735 1.94802 29.5986 4.39148 32.6267C5.561 34.076 7.31273 35.6943 8.73756 36.6417C9.17335 36.9315 9.36144 37.0081 9.70817 37.0369C10.2429 37.0812 10.7202 36.9121 11.0478 36.5622C11.2801 36.3141 15.7236 29.6179 15.9625 29.1559C16.4164 28.2782 16.1018 27.5151 14.9459 26.6893C14.428 26.3194 13.4654 25.3061 13.0844 24.73C12.3469 23.6146 11.8695 22.2889 11.6999 20.8856C11.603 20.0847 11.4311 19.6951 11.0279 19.3628C10.7538 19.1368 10.2218 18.9458 9.92321 18.9663C9.84534 18.9716 7.91853 19.0917 5.64138 19.2332ZM29.5408 19.0597C29.1414 19.185 28.7325 19.5268 28.547 19.8903C28.4628 20.0553 28.3561 20.5032 28.3098 20.8856C28.131 22.3654 27.6403 23.6776 26.8247 24.8574C26.3988 25.4736 25.5286 26.3486 24.7077 26.9863C24.4304 27.2017 24.1314 27.5014 24.0434 27.6522C23.8377 28.0046 23.8291 28.7538 24.0264 29.1238C24.3043 29.6449 28.7305 36.317 28.961 36.5622C29.2899 36.9123 29.767 37.0812 30.3015 37.0369C30.7989 36.9956 31.2811 36.7054 32.5782 35.667C34.7863 33.8991 36.6521 31.5713 37.9394 28.9781C38.9077 27.0273 39.5582 24.9545 39.863 22.8486C40.0528 21.5366 40.0457 20.7881 39.8396 20.3908C39.6603 20.045 39.3046 19.7281 38.9405 19.5897C38.8209 19.5443 36.9703 19.4023 34.8281 19.2743C32.6858 19.1462 30.6863 19.0248 30.3847 19.0044C30.0703 18.983 29.7103 19.0066 29.5408 19.0597Z',
    },
  ],
};
export const trash: IconConfig = {
  width: 10,
  height: 12,
  paths: [
    {
      d: 'M1.00016 10.6667C1.00016 11.4 1.60016 12 2.3335 12H7.66683C8.40016 12 9.00016 11.4 9.00016 10.6667V2.66667H1.00016V10.6667ZM9.66683 0.666667H7.3335L6.66683 0H3.3335L2.66683 0.666667H0.333496V2H9.66683V0.666667Z',
    },
  ],
};
export const underline: IconConfig = {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 17C15.31 17 18 14.31 18 11V3H15.5V11C15.5 12.93 13.93 14.5 12 14.5C10.07 14.5 8.5 12.93 8.5 11V3H6V11C6 14.31 8.69 17 12 17ZM5 19V21H19V19H5Z',
    },
  ],
};
export const user: IconConfig = {
  width: 22,
  height: 22,
  paths: [
    {
      d: 'M11 10.628C9.4875 10.628 8.25 10.132 7.2875 9.1401C6.325 8.14815 5.84375 6.87279 5.84375 5.31401C5.84375 3.75523 6.325 2.47987 7.2875 1.48792C8.25 0.495975 9.4875 0 11 0C12.5125 0 13.75 0.495975 14.7125 1.48792C15.675 2.47987 16.1562 3.75523 16.1562 5.31401C16.1562 6.87279 15.675 8.14815 14.7125 9.1401C13.75 10.132 12.5125 10.628 11 10.628ZM2.0625 22C1.48958 22 1.0026 21.7933 0.601562 21.38C0.200521 20.9667 0 20.4648 0 19.8744V18.6699C0 17.7724 0.217708 17.0048 0.653125 16.3671C1.08854 15.7295 1.65 15.2453 2.3375 14.9147C3.87292 14.2061 5.34531 13.6747 6.75469 13.3205C8.16406 12.9662 9.57917 12.7891 11 12.7891C12.4208 12.7891 13.8302 12.9721 15.2281 13.3382C16.626 13.7042 18.0927 14.2297 19.6281 14.9147C20.3385 15.2453 20.9115 15.7295 21.3469 16.3671C21.7823 17.0048 22 17.7724 22 18.6699V19.8744C22 20.4648 21.7995 20.9667 21.3984 21.38C20.9974 21.7933 20.5104 22 19.9375 22H2.0625Z',
    },
  ],
};
export const video: IconConfig = {
  width: 20,
  height: 16,
  paths: [
    {
      d: 'M16 0L17.82 3.64C17.9 3.8 17.78 4 17.6 4H15.62C15.24 4 14.89 3.79 14.73 3.45L13 0H11L12.82 3.64C12.9 3.8 12.78 4 12.6 4H10.62C10.24 4 9.89 3.79 9.73 3.45L8 0H6L7.82 3.64C7.9 3.8 7.78 4 7.6 4H5.62C5.24 4 4.89 3.79 4.72 3.45L3 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V1C20 0.45 19.55 0 19 0H16Z',
    },
  ],
};
export const virus: IconConfig = {
  width: 40,
  height: 40,
  paths: [
    {
      d: 'M19.046 0.221233C18.3812 0.572197 18.1101 1.048 18.0128 2.03425C17.9038 3.14111 17.7718 3.69136 17.4533 4.36756C16.8435 5.66207 15.6367 6.71655 14.2223 7.19076C13.2404 7.51995 11.916 7.54173 10.9823 7.24408C10.2551 7.01223 9.41558 6.52291 8.84872 6.00036C8.62213 5.79141 8.25971 5.54023 8.04335 5.44195C6.74754 4.8536 5.25122 5.82558 5.25855 7.25093C5.26136 7.79394 5.50673 8.29706 6.0962 8.96849C7.38573 10.4373 7.79123 12.388 7.19152 14.2382C6.49053 16.4011 4.69498 17.7941 2.36457 17.9828C1.40142 18.0608 1.07946 18.171 0.630402 18.5761C0.163514 18.9974 0 19.3733 0 20.0254C0 20.6711 0.30328 21.2632 0.820574 21.6276C1.14948 21.8593 1.33655 21.9097 2.12747 21.9802C3.26249 22.0815 4.09602 22.3238 4.83408 22.767C5.95493 23.4401 6.70398 24.3874 7.16702 25.7179C7.80625 27.5542 7.40741 29.5303 6.0962 31.0239C5.82502 31.3328 5.52606 31.7552 5.43192 31.9626C4.9807 32.9557 5.46852 34.1576 6.4972 34.5873C7.25329 34.9032 8.0901 34.6914 8.84872 33.9921C10.6265 32.3533 13.0969 32.0762 15.3455 33.2633C15.6545 33.4263 16.164 33.8132 16.4777 34.123C17.424 35.0575 17.8876 36.1053 17.9808 37.5197C18.0532 38.618 18.2204 39.0555 18.7439 39.5163C19.6372 40.3025 20.9891 40.1081 21.6748 39.0948C21.8625 38.8173 21.9151 38.5817 21.9824 37.7154C22.1573 35.4657 23.0758 34.0344 24.9213 33.1359C25.9007 32.6591 26.6184 32.4801 27.5458 32.4815C28.8874 32.4834 29.927 32.8938 30.9588 33.8286C31.6655 34.4691 32.1767 34.7281 32.7387 34.7311C34.1626 34.7384 35.136 33.2421 34.5488 31.9488C34.4512 31.7338 34.1371 31.3032 33.8507 30.9917C32.5466 29.5731 32.1518 27.6214 32.7898 25.7471C33.1066 24.8168 33.4354 24.2844 34.1563 23.5348C35.1059 22.5477 36.4757 21.9773 37.9217 21.9669C38.5673 21.9623 39.0972 21.7277 39.5011 21.2677C39.8958 20.8181 39.9868 20.5728 39.9868 19.9579C39.9868 19.3206 39.6801 18.7269 39.1627 18.3624C38.8237 18.1236 38.6579 18.0805 37.8301 18.0164C36.1689 17.8877 35.1422 17.4637 34.1976 16.5161C32.0628 14.3748 31.9122 11.1094 33.8507 9.00068C34.4604 8.33752 34.7254 7.80915 34.7282 7.25093C34.7356 5.82699 33.2393 4.8536 31.946 5.44082C31.731 5.53844 31.3004 5.85252 30.9889 6.1389C29.5242 7.48531 27.5724 7.8528 25.6372 7.14646C24.6334 6.78019 24.1068 6.4389 23.3847 5.68694C22.4953 4.76077 21.9739 3.43238 21.9641 2.06785C21.9581 1.2209 21.4149 0.366444 20.7148 0.102399C20.2525 -0.0718153 19.4997 -0.0182181 19.046 0.221233ZM25.7383 12.4171C26.5974 12.8417 27.2117 13.4684 27.6261 14.3433C27.9059 14.9339 27.9251 15.0408 27.9251 16.0089C27.9251 16.9971 27.9107 17.0727 27.6032 17.6985C26.3857 20.1765 23.2555 20.7483 21.2566 18.8578C19.4017 17.1035 19.6467 14.1209 21.7626 12.6988C22.5919 12.1414 23.0494 12.0153 24.134 12.0452C24.9596 12.068 25.096 12.0997 25.7383 12.4171ZM12.8399 18.2041C14.3947 19.0039 14.3384 21.1561 12.7453 21.8216C12.2997 22.0077 11.6365 22.0079 11.1918 21.8221C9.61767 21.1644 9.60434 18.8539 11.1707 18.1746C11.6357 17.9729 12.4173 17.9868 12.8399 18.2041ZM22.507 25.0814C23.1285 25.2379 23.7752 25.8974 23.9268 26.5294C24.1482 27.4521 23.7361 28.34 22.8911 28.7611C22.0685 29.1711 21.2431 29.0405 20.6016 28.3991C19.9602 27.7576 19.8296 26.9322 20.2396 26.1096C20.5029 25.5812 20.9799 25.1905 21.5174 25.063C21.9593 24.9581 22.0225 24.9594 22.507 25.0814Z',
    },
  ],
};
export const zoomIn: IconConfig = {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M12.4999 10.9996H11.7099L11.4299 10.7296C12.6299 9.32965 13.2499 7.41965 12.9099 5.38965C12.4399 2.60965 10.1199 0.389649 7.3199 0.049649C3.0899 -0.470351 -0.460103 3.08965 0.0498967 7.31965C0.389897 10.1196 2.6099 12.4396 5.3899 12.9096C7.4199 13.2496 9.3299 12.6296 10.7299 11.4296L10.9999 11.7096V12.4996L15.2599 16.7496C15.6699 17.1596 16.3299 17.1596 16.7399 16.7496L16.7499 16.7396C17.1599 16.3296 17.1599 15.6696 16.7499 15.2596L12.4999 10.9996ZM6.4999 10.9996C4.0099 10.9996 1.9999 8.98965 1.9999 6.49965C1.9999 4.00965 4.0099 1.99965 6.4999 1.99965C8.9899 1.99965 10.9999 4.00965 10.9999 6.49965C10.9999 8.98965 8.9899 10.9996 6.4999 10.9996ZM6.4999 3.99965C6.2199 3.99965 5.9999 4.21965 5.9999 4.49965V5.99965H4.4999C4.2199 5.99965 3.9999 6.21965 3.9999 6.49965C3.9999 6.77965 4.2199 6.99965 4.4999 6.99965H5.9999V8.49965C5.9999 8.77965 6.2199 8.99965 6.4999 8.99965C6.7799 8.99965 6.9999 8.77965 6.9999 8.49965V6.99965H8.4999C8.7799 6.99965 8.9999 6.77965 8.9999 6.49965C8.9999 6.21965 8.7799 5.99965 8.4999 5.99965H6.9999V4.49965C6.9999 4.21965 6.7799 3.99965 6.4999 3.99965Z',
    },
  ],
};
export const zoomOut: IconConfig = {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M12.5001 10.9996H11.7101L11.4301 10.7296C12.6301 9.32965 13.2501 7.41965 12.9101 5.38965C12.4401 2.60965 10.1201 0.389649 7.32014 0.049649C3.09014 -0.470351 -0.469863 3.08965 0.0501373 7.31965C0.390137 10.1196 2.61014 12.4396 5.39014 12.9096C7.42014 13.2496 9.33014 12.6296 10.7301 11.4296L11.0001 11.7096V12.4996L15.2601 16.7496C15.6701 17.1596 16.3301 17.1596 16.7401 16.7496L16.7501 16.7396C17.1601 16.3296 17.1601 15.6696 16.7501 15.2596L12.5001 10.9996ZM6.50014 10.9996C4.01014 10.9996 2.00014 8.98965 2.00014 6.49965C2.00014 4.00965 4.01014 1.99965 6.50014 1.99965C8.99014 1.99965 11.0001 4.00965 11.0001 6.49965C11.0001 8.98965 8.99014 10.9996 6.50014 10.9996ZM4.50014 5.99965H8.50014C8.78014 5.99965 9.00014 6.21965 9.00014 6.49965C9.00014 6.77965 8.78014 6.99965 8.50014 6.99965H4.50014C4.22014 6.99965 4.00014 6.77965 4.00014 6.49965C4.00014 6.21965 4.22014 5.99965 4.50014 5.99965Z',
    },
  ],
};
export const plus: IconConfig = {
  width: 10,
  height: 10,
  paths: [
    {
      d: 'M9.00016 5.66634H5.66683V8.99967C5.66683 9.36634 5.36683 9.66634 5.00016 9.66634C4.6335 9.66634 4.3335 9.36634 4.3335 8.99967V5.66634H1.00016C0.633496 5.66634 0.333496 5.36634 0.333496 4.99967C0.333496 4.63301 0.633496 4.33301 1.00016 4.33301H4.3335V0.999674C4.3335 0.633008 4.6335 0.333008 5.00016 0.333008C5.36683 0.333008 5.66683 0.633008 5.66683 0.999674V4.33301H9.00016C9.36683 4.33301 9.66683 4.63301 9.66683 4.99967C9.66683 5.36634 9.36683 5.66634 9.00016 5.66634Z',
    },
  ],
};

export const headingOne = {
  width: 30,
  height: 30,
  paths: [
    {
      d: 'M5.77778 4H18.2222C19.2 4 20 4.8 20 5.77778V18.2222C20 19.2 19.2 20 18.2222 20H5.77778C4.8 20 4 19.2 4 18.2222V5.77778C4 4.8 4.8 4 5.77778 4ZM12.8889 14.6667H11.5556V10.6667H10.2222V9.33333H12.8889V14.6667Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};

export const headingTwo = {
  width: 30,
  height: 30,
  paths: [
    {
      d: 'M5.77778 4H18.2222C19.2 4 20 4.8 20 5.77778V18.2222C20 19.2 19.2 20 18.2222 20H5.77778C4.8 20 4 19.2 4 18.2222V5.77778C4 4.8 4.8 4 5.77778 4ZM13.3333 12.4444H11.5556V13.3333H14.2222V14.6667H10.2222V12.4444C10.2222 11.9556 10.6222 11.5556 11.1111 11.5556H12.8889V10.6667H10.2222V9.33333H13.3333C13.8222 9.33333 14.2222 9.73333 14.2222 10.2222V11.5556C14.2222 12.0444 13.8222 12.4444 13.3333 12.4444Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};
export const shield = {
  width: 19,
  height: 20,
  paths: [
    {
      d: 'M9.16448 19.8456L8.19245 19.334C2.32094 16.2437 -0.641542 9.51063 1.04704 3.09401C1.1448 2.72253 1.51859 2.4924 1.89818 2.5513C2.87935 2.70353 4.73208 2.89014 6.11776 2.42825C7.16784 2.07822 8.21793 1.12754 8.92445 0.377884C9.38822 -0.114214 10.2089 -0.129558 10.6809 0.354579C11.4173 1.1098 12.4948 2.07951 13.461 2.42825C14.7287 2.8858 16.6761 2.69115 17.6904 2.54155C18.0658 2.48618 18.4322 2.7156 18.5287 3.08256C20.2191 9.50588 17.2535 16.246 11.3759 19.3395L10.4143 19.8456C10.0231 20.0515 9.55565 20.0515 9.16448 19.8456Z',
    },
  ],
};

export const defaultFile: IconConfig = {
  width: 55,
  height: 72,
  paths: [
    {
      opacity: 0.3,
      d: 'm46.6 16.4c-1.9 0-3.6-0.7-4.9-2-1.3-1.3-2-3-2-4.9v-9.5h-30.7c-2.4 0-4.7 0.9-6.4 2.6-1.7 1.7-2.6 4-2.6 6.4v54c0 2.4 1 4.7 2.6 6.4 1.7 1.7 4 2.6 6.4 2.6h36.8c2.4 0 4.7-0.9 6.4-2.6 1.7-1.7 2.6-4 2.6-6.4v-46.6z',
    },
    { d: 'm54.8 16.4h-8.2c-1.9 0-3.6-0.7-4.9-2-1.3-1.3-2-3-2-4.9v-9.5z' },
    {
      d: 'm43.5 50.3h-34.4c-0.3 0-0.6-0.2-0.9-0.4-0.2-0.2-0.3-0.5-0.3-0.9 0-0.3 0.1-0.6 0.3-0.9 0.3-0.2 0.6-0.3 0.9-0.3h34.4c0.4 0 0.7 0.1 0.9 0.3 0.2 0.3 0.4 0.6 0.4 0.9q0 0.3-0.1 0.5-0.1 0.2-0.3 0.4-0.2 0.2-0.4 0.3-0.2 0.1-0.5 0.1z',
    },
    {
      d: 'm43.5 36.2h-34.4c-0.3 0-0.6-0.1-0.9-0.4-0.2-0.2-0.3-0.5-0.3-0.8 0-0.4 0.1-0.7 0.3-0.9 0.3-0.3 0.6-0.4 0.9-0.4h34.4q0.3 0 0.5 0.1 0.2 0.1 0.4 0.3 0.2 0.1 0.3 0.4 0.1 0.2 0.1 0.5c0 0.3-0.2 0.6-0.4 0.8-0.2 0.3-0.5 0.4-0.9 0.4z',
    },
    {
      d: 'm43.5 43.2h-34.4c-0.3 0-0.6-0.1-0.9-0.3-0.2-0.3-0.3-0.6-0.3-0.9 0-0.3 0.1-0.7 0.3-0.9 0.3-0.2 0.6-0.4 0.9-0.4h34.4c0.4 0 0.7 0.2 0.9 0.4 0.2 0.2 0.4 0.6 0.4 0.9q0 0.2-0.1 0.5-0.1 0.2-0.3 0.4-0.2 0.1-0.4 0.2-0.2 0.1-0.5 0.1z',
    },
    {
      d: 'm30 29.2h-20.9c-0.3 0-0.6-0.2-0.9-0.4-0.2-0.2-0.3-0.6-0.3-0.9 0-0.3 0.1-0.6 0.3-0.9 0.3-0.2 0.6-0.3 0.9-0.3h20.9c0.3 0 0.6 0.1 0.8 0.3 0.3 0.3 0.4 0.6 0.4 0.9 0 0.3-0.1 0.7-0.4 0.9-0.2 0.2-0.5 0.4-0.8 0.4z',
    },
    {
      d: 'm30 22.1h-20.9c-0.3 0-0.6-0.1-0.9-0.3-0.2-0.3-0.3-0.6-0.3-0.9 0-0.4 0.1-0.7 0.3-0.9 0.3-0.2 0.6-0.4 0.9-0.4h20.9c0.3 0 0.6 0.2 0.8 0.4 0.3 0.2 0.4 0.5 0.4 0.9 0 0.3-0.1 0.6-0.4 0.9-0.2 0.2-0.5 0.3-0.8 0.3z',
    },
    {
      d: 'm42.9 19.6h-5.9c-1 0-1.8 0.9-1.8 1.9v5.9c0 1 0.8 1.8 1.8 1.8h5.9c1 0 1.9-0.8 1.9-1.8v-5.9c0-1-0.9-1.9-1.9-1.9z',
    },
  ],
};

export const pdf = {
  width: 1424,
  height: 1600,
  paths: [
    {
      d: 'M178 0h786l3 3 8 6 9 9 7 8 9 10 9 11 11 12 9 11 11 12 7 8 12 14 9 10 7 8 9 10 9 11 11 12 7 8 12 14 9 10 7 8 12 14 9 10 7 8 12 14 9 10 7 8 12 14 9 10 7 8 12 14 9 10 7 8 12 14 9 10 7 8 10 13 3 7 1 8v188h27l21 1 15 3 15 6 13 8 12 10 8 10 8 13 6 16 3 17v478l-2 14-5 16-8 15-7 9-5 6-11 9-10 6-15 6-18 4-47 1v312l-1 17-4 14-6 11-11 12-10 7-11 5-7 3H181l-15-6-13-9-8-8-7-11-4-9-3-15v-324H82l-17-4-16-7-13-9-7-6-9-11-8-13-5-12-3-12-1-8-1-69H1V712h1l1-56 2-15 4-12 8-16 7-9 8-9 13-10 16-8 14-4 7-1 17-1h32V56l2-10 5-13 10-14 8-7 11-7 10-4zm17 63v509h1033l1-1V416l-3-1h-90l-191-1-10-4-8-8-4-8-2-11-1-320zm78 608-35 1-47 3-42 5-2 1v462h101l3-2V975l12 2h41l30-3 26-5 23-7 16-7 17-9 14-10 12-11 8-8 10-14 9-17 7-20 4-18 2-17v-25l-3-21-5-18-8-18-9-15-8-10-13-13-17-12-17-9-19-7-14-4-21-4-29-3-23-1zm405 0-52 2-40 3-33 4-2 1v460l46 4 39 2h58l31-2 31-4 33-7 26-8 20-8 17-8 17-10 21-16 19-19 8-10 14-21 9-17 8-20 5-15 6-25 4-30 1-20v-18l-2-27-4-25-7-25-9-22-11-20-10-14-12-14-10-10-14-11-21-14-17-9-23-9-19-6-29-6-24-3-24-2-25-1zm432 3-75 1v467l58 1h46l1-1 1-187 167-1v-85l-167-1-1-107h179l1-1v-84l-1-1zm-915 544v302h1033l1-1v-300l-7-1z',
    },
    {
      d: 'M685 752h37l17 2 22 5 20 8 14 8 12 9 5 4 7 8 9 11 8 13 8 20 5 18 3 21v44l-2 17-4 20-7 21-8 16-8 13-9 11-11 11-14 10-19 10-21 7-18 4-17 2-19 1h-14l-18-1-7-2V757l3-2 13-2zm-413-1h40l20 4 17 8 10 8 9 10 6 12 4 16 1 14-2 14-5 15-7 13-7 8-10 8-14 7-11 4-14 3-8 1h-38l-12-2-1-23v-55l1-61 5-2z',
    },
  ],
};

export default {
  alertDots,
  alignCenter,
  alignLeft,
  arrowLeft,
  alignRight,
  angleDown,
  angleLeft,
  angleRight,
  angleUp,
  arrowRight,
  barsDuo,
  barsSolid,
  bars,
  bold,
  bell,
  bus,
  camera,
  code,
  copy,
  portfolio,
  calendar,
  check,
  buildings,
  crop,
  cross,
  crossFilled,
  crossSearch,
  dashboard,
  dotsTriangle,
  dots,
  dotsList,
  drops,
  eye,
  emergencyRequest,
  fileBucket,
  fileDownload,
  fileUpload,
  file,
  fileAdd,
  files,
  folders,
  filter,
  fire,
  gear,
  groupAdd,
  group,
  h,
  headingOne,
  headingTwo,
  history,
  houseBroken,
  quote,
  image,
  info,
  italic,
  labelFilled,
  label,
  letter,
  linkAngle,
  link,
  list,
  grid,
  global,
  notificationAlert,
  notificationCheck,
  numericList,
  pen,
  phone,
  pin,
  property,
  play,
  plus,
  lplus,
  rectangleBig,
  rectangleMiddle,
  rectangleSmall,
  revert,
  revertLeft,
  revertRight,
  questionmark,
  rotateLeft,
  rotateRight,
  search,
  textAlignLeft,
  textAlignRight,
  textAlignCenter,
  textAlignJustify,
  time,
  timeFilled,
  toxic,
  trash,
  underline,
  user,
  video,
  virus,
  zoomIn,
  zoomOut,
  defaultFile,
  shield,
  pdf,
};
